// @generated by Peggy 4.0.3.
//
// https://peggyjs.org/


function peg$subclass(child, parent) {
  function C() { this.constructor = child; }
  C.prototype = parent.prototype;
  child.prototype = new C();
}

function peg$SyntaxError(message, expected, found, location) {
  var self = Error.call(this, message);
  // istanbul ignore next Check is a necessary evil to support older environments
  if (Object.setPrototypeOf) {
    Object.setPrototypeOf(self, peg$SyntaxError.prototype);
  }
  self.expected = expected;
  self.found = found;
  self.location = location;
  self.name = "SyntaxError";
  return self;
}

peg$subclass(peg$SyntaxError, Error);

function peg$padEnd(str, targetLength, padString) {
  padString = padString || " ";
  if (str.length > targetLength) { return str; }
  targetLength -= str.length;
  padString += padString.repeat(targetLength);
  return str + padString.slice(0, targetLength);
}

peg$SyntaxError.prototype.format = function(sources) {
  var str = "Error: " + this.message;
  if (this.location) {
    var src = null;
    var k;
    for (k = 0; k < sources.length; k++) {
      if (sources[k].source === this.location.source) {
        src = sources[k].text.split(/\r\n|\n|\r/g);
        break;
      }
    }
    var s = this.location.start;
    var offset_s = (this.location.source && (typeof this.location.source.offset === "function"))
      ? this.location.source.offset(s)
      : s;
    var loc = this.location.source + ":" + offset_s.line + ":" + offset_s.column;
    if (src) {
      var e = this.location.end;
      var filler = peg$padEnd("", offset_s.line.toString().length, ' ');
      var line = src[s.line - 1];
      var last = s.line === e.line ? e.column : line.length + 1;
      var hatLen = (last - s.column) || 1;
      str += "\n --> " + loc + "\n"
          + filler + " |\n"
          + offset_s.line + " | " + line + "\n"
          + filler + " | " + peg$padEnd("", s.column - 1, ' ')
          + peg$padEnd("", hatLen, "^");
    } else {
      str += "\n at " + loc;
    }
  }
  return str;
};

peg$SyntaxError.buildMessage = function(expected, found) {
  var DESCRIBE_EXPECTATION_FNS = {
    literal: function(expectation) {
      return "\"" + literalEscape(expectation.text) + "\"";
    },

    class: function(expectation) {
      var escapedParts = expectation.parts.map(function(part) {
        return Array.isArray(part)
          ? classEscape(part[0]) + "-" + classEscape(part[1])
          : classEscape(part);
      });

      return "[" + (expectation.inverted ? "^" : "") + escapedParts.join("") + "]";
    },

    any: function() {
      return "any character";
    },

    end: function() {
      return "end of input";
    },

    other: function(expectation) {
      return expectation.description;
    }
  };

  function hex(ch) {
    return ch.charCodeAt(0).toString(16).toUpperCase();
  }

  function literalEscape(s) {
    return s
      .replace(/\\/g, "\\\\")
      .replace(/"/g,  "\\\"")
      .replace(/\0/g, "\\0")
      .replace(/\t/g, "\\t")
      .replace(/\n/g, "\\n")
      .replace(/\r/g, "\\r")
      .replace(/[\x00-\x0F]/g,          function(ch) { return "\\x0" + hex(ch); })
      .replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) { return "\\x"  + hex(ch); });
  }

  function classEscape(s) {
    return s
      .replace(/\\/g, "\\\\")
      .replace(/\]/g, "\\]")
      .replace(/\^/g, "\\^")
      .replace(/-/g,  "\\-")
      .replace(/\0/g, "\\0")
      .replace(/\t/g, "\\t")
      .replace(/\n/g, "\\n")
      .replace(/\r/g, "\\r")
      .replace(/[\x00-\x0F]/g,          function(ch) { return "\\x0" + hex(ch); })
      .replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) { return "\\x"  + hex(ch); });
  }

  function describeExpectation(expectation) {
    return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
  }

  function describeExpected(expected) {
    var descriptions = expected.map(describeExpectation);
    var i, j;

    descriptions.sort();

    if (descriptions.length > 0) {
      for (i = 1, j = 1; i < descriptions.length; i++) {
        if (descriptions[i - 1] !== descriptions[i]) {
          descriptions[j] = descriptions[i];
          j++;
        }
      }
      descriptions.length = j;
    }

    switch (descriptions.length) {
      case 1:
        return descriptions[0];

      case 2:
        return descriptions[0] + " or " + descriptions[1];

      default:
        return descriptions.slice(0, -1).join(", ")
          + ", or "
          + descriptions[descriptions.length - 1];
    }
  }

  function describeFound(found) {
    return found ? "\"" + literalEscape(found) + "\"" : "end of input";
  }

  return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
};

function peg$parse(input, options) {
  options = options !== undefined ? options : {};

  var peg$FAILED = {};
  var peg$source = options.grammarSource;

  var peg$startRuleFunctions = { Start: peg$parseStart };
  var peg$startRuleFunction = peg$parseStart;

  var peg$c0 = "===";
  var peg$c1 = "---";
  var peg$c2 = "#";
  var peg$c3 = "{";
  var peg$c4 = "}";
  var peg$c5 = "[";
  var peg$c6 = "][";
  var peg$c7 = "]";
  var peg$c8 = "|";
  var peg$c9 = "if";
  var peg$c10 = "||";
  var peg$c11 = "readonly";
  var peg$c12 = "editable";
  var peg$c13 = "hidden";
  var peg$c14 = "hide";
  var peg$c15 = "show";
  var peg$c16 = "=";
  var peg$c17 = "auto";
  var peg$c18 = ":";
  var peg$c19 = "(";
  var peg$c20 = ")";
  var peg$c21 = "-";
  var peg$c22 = "<";
  var peg$c23 = ">";
  var peg$c24 = "\\>";
  var peg$c25 = ">=";
  var peg$c26 = "em";
  var peg$c27 = "px";
  var peg$c28 = "rem";
  var peg$c29 = "*";
  var peg$c30 = "col";
  var peg$c31 = "%";
  var peg$c32 = "\"";
  var peg$c33 = "\\\"";
  var peg$c34 = "'";
  var peg$c35 = "\\'";
  var peg$c36 = ".";
  var peg$c37 = "text";
  var peg$c38 = "password";
  var peg$c39 = "number";
  var peg$c40 = "select";
  var peg$c41 = "switch";
  var peg$c42 = "date";
  var peg$c43 = "datetime";
  var peg$c44 = "mail";
  var peg$c45 = "dayofyear";
  var peg$c46 = "monthofyear";
  var peg$c47 = "month";
  var peg$c48 = "year";
  var peg$c49 = "time";
  var peg$c50 = "duration";
  var peg$c51 = "ref";
  var peg$c52 = "file";
  var peg$c53 = "image";
  var peg$c54 = "address";
  var peg$c55 = "currency";
  var peg$c56 = "geolocation";
  var peg$c57 = "/";
  var peg$c58 = "n";
  var peg$c59 = "\t";
  var peg$c60 = "  ";
  var peg$c61 = "\n";
  var peg$c62 = "\r\n";
  var peg$c63 = "\r";

  var peg$r0 = /^[a-zA-Z_]/;
  var peg$r1 = /^[a-zA-Z0-9_]/;
  var peg$r2 = /^[|-}]/;
  var peg$r3 = /^[a-z0-9_\-]/i;
  var peg$r4 = /^[a-z_]/i;
  var peg$r5 = /^[a-z0-9:_\-]/i;
  var peg$r6 = /^[^ \t\n\r'"|}=>]/;
  var peg$r7 = /^[^ \t\n\r'"|}=>)]/;
  var peg$r8 = /^[^\n\r"]/;
  var peg$r9 = /^[^\n\r']/;
  var peg$r10 = /^[^\n\r\\""]/;
  var peg$r11 = /^[0-9.,]/;
  var peg$r12 = /^[\t ]/;
  var peg$r13 = /^[\n\r]/;

  var peg$e0 = peg$literalExpectation("===", false);
  var peg$e1 = peg$literalExpectation("---", false);
  var peg$e2 = peg$literalExpectation("#", false);
  var peg$e3 = peg$literalExpectation("{", false);
  var peg$e4 = peg$literalExpectation("}", false);
  var peg$e5 = peg$literalExpectation("[", false);
  var peg$e6 = peg$literalExpectation("][", false);
  var peg$e7 = peg$literalExpectation("]", false);
  var peg$e8 = peg$classExpectation([["a", "z"], ["A", "Z"], "_"], false, false);
  var peg$e9 = peg$classExpectation([["a", "z"], ["A", "Z"], ["0", "9"], "_"], false, false);
  var peg$e10 = peg$literalExpectation("|", false);
  var peg$e11 = peg$literalExpectation("if", false);
  var peg$e12 = peg$literalExpectation("||", false);
  var peg$e13 = peg$literalExpectation("readonly", false);
  var peg$e14 = peg$literalExpectation("editable", false);
  var peg$e15 = peg$literalExpectation("hidden", false);
  var peg$e16 = peg$literalExpectation("hide", false);
  var peg$e17 = peg$literalExpectation("show", false);
  var peg$e18 = peg$classExpectation([["|", "}"]], false, false);
  var peg$e19 = peg$literalExpectation("=", false);
  var peg$e20 = peg$literalExpectation("auto", false);
  var peg$e21 = peg$literalExpectation(":", false);
  var peg$e22 = peg$classExpectation([["a", "z"], ["0", "9"], "_", "-"], false, true);
  var peg$e23 = peg$literalExpectation("(", false);
  var peg$e24 = peg$literalExpectation(")", false);
  var peg$e25 = peg$classExpectation([["a", "z"], "_"], false, true);
  var peg$e26 = peg$literalExpectation("-", false);
  var peg$e27 = peg$literalExpectation("<", false);
  var peg$e28 = peg$literalExpectation(">", false);
  var peg$e29 = peg$literalExpectation("\\>", false);
  var peg$e30 = peg$literalExpectation(">=", false);
  var peg$e31 = peg$classExpectation([["a", "z"], ["0", "9"], ":", "_", "-"], false, true);
  var peg$e32 = peg$literalExpectation("em", false);
  var peg$e33 = peg$literalExpectation("px", false);
  var peg$e34 = peg$literalExpectation("rem", false);
  var peg$e35 = peg$literalExpectation("*", false);
  var peg$e36 = peg$literalExpectation("col", false);
  var peg$e37 = peg$literalExpectation("%", false);
  var peg$e38 = peg$classExpectation([" ", "\t", "\n", "\r", "'", "\"", "|", "}", "=", ">"], true, false);
  var peg$e39 = peg$classExpectation([" ", "\t", "\n", "\r", "'", "\"", "|", "}", "=", ">", ")"], true, false);
  var peg$e40 = peg$literalExpectation("\"", false);
  var peg$e41 = peg$literalExpectation("\\\"", false);
  var peg$e42 = peg$classExpectation(["\n", "\r", "\""], true, false);
  var peg$e43 = peg$literalExpectation("'", false);
  var peg$e44 = peg$literalExpectation("\\'", false);
  var peg$e45 = peg$classExpectation(["\n", "\r", "'"], true, false);
  var peg$e46 = peg$literalExpectation(".", false);
  var peg$e47 = peg$literalExpectation("Text", true);
  var peg$e48 = peg$literalExpectation("Password", true);
  var peg$e49 = peg$literalExpectation("Number", true);
  var peg$e50 = peg$literalExpectation("Select", true);
  var peg$e51 = peg$literalExpectation("Switch", true);
  var peg$e52 = peg$literalExpectation("Date", true);
  var peg$e53 = peg$literalExpectation("DateTime", true);
  var peg$e54 = peg$literalExpectation("Mail", true);
  var peg$e55 = peg$literalExpectation("DayOfYear", true);
  var peg$e56 = peg$literalExpectation("MonthOfYear", true);
  var peg$e57 = peg$literalExpectation("Month", true);
  var peg$e58 = peg$literalExpectation("Year", true);
  var peg$e59 = peg$literalExpectation("Time", true);
  var peg$e60 = peg$literalExpectation("Duration", true);
  var peg$e61 = peg$literalExpectation("Ref", true);
  var peg$e62 = peg$literalExpectation("File", true);
  var peg$e63 = peg$literalExpectation("Image", true);
  var peg$e64 = peg$literalExpectation("Address", true);
  var peg$e65 = peg$literalExpectation("Currency", true);
  var peg$e66 = peg$literalExpectation("Geolocation", true);
  var peg$e67 = peg$literalExpectation("/", false);
  var peg$e68 = peg$literalExpectation("n", true);
  var peg$e69 = peg$classExpectation(["\n", "\r", "\\", "\"", "\""], true, false);
  var peg$e70 = peg$classExpectation([["0", "9"], ".", ","], false, false);
  var peg$e71 = peg$anyExpectation();
  var peg$e72 = peg$otherExpectation("End of Block (empty lines)");
  var peg$e73 = peg$otherExpectation("End of Line (return)");
  var peg$e74 = peg$literalExpectation("\t", false);
  var peg$e75 = peg$literalExpectation("  ", false);
  var peg$e76 = peg$otherExpectation("whitespace");
  var peg$e77 = peg$classExpectation(["\t", " "], false, false);
  var peg$e78 = peg$classExpectation(["\n", "\r"], false, false);
  var peg$e79 = peg$otherExpectation("end of line");
  var peg$e80 = peg$literalExpectation("\n", false);
  var peg$e81 = peg$literalExpectation("\r\n", false);
  var peg$e82 = peg$literalExpectation("\r", false);

  var peg$f0 = function(formDefinition) {
      result.definition = text();
      addUnsupportedFieldTypeHints(result.definition);
      completeSections();
      applyDefaultDirectives();
      applyAutoWidthHints();
      
      return result; 
    };
  var peg$f1 = function(rootDirectives) {
      applyDirectives(result.sections[0], rootDirectives);
    };
  var peg$f2 = function(directives) { return directives };
  var peg$f3 = function(directives, section) {
      section.directives = directives;
      addConsumedRange(location().start.offset, section.offset - location().start.offset);
      addSection(location().start.offset, text().length, section);
    };
  var peg$f4 = function(ss) {
      addSection(location().start.offset, text().length, ss);
    };
  var peg$f5 = function(td, trailingDefinitionSeparator) {
      if(trailingDefinitionSeparator){
        td.length = location().start.offset + text().length - td.offset;
      }
      addTypeDefinition(td.offset, td.length, td.fieldName, td.spec);
    };
  var peg$f6 = function() {
      completeCurrentParagraph(location().start.offset, text().length, location().start.offset, []);
      addNextParagraph();
    };
  var peg$f7 = function(directives, section) {
      section.directives = directives;
      addConsumedRange(location().start.offset, section.offset - location().start.offset);
      return section;
    };
  var peg$f8 = function(section) {
      section.directives = [];
      return section;
    };
  var peg$f9 = function(chars) {
      return {
        level: 1,
        title: chars.join('').trim(),
        type: "SETEXT",
        offset: location().start.offset,
        length: text().length
      };
    };
  var peg$f10 = function(chars) {
      return {
        level: 2,
        title: chars.join('').trim(),
        type: "SETEXT",
        offset: location().start.offset,
        length: text().length
      };
    };
  var peg$f11 = function(pounds, title) {
      return {
        level: pounds.length,
        title: title || '',
        type: "ATX",
        offset: location().start.offset,
        length: text().length
      };
    };
  var peg$f12 = function(chars) {
      return chars.join('').trim();
    };
  var peg$f13 = function(fp) {
      //special case: when a block consists of just one field, then the directives
      //apply to the field, not the block
      addPlaceholder(location().start.offset, text().length, fp.directives, fp.field.name, fp.field.label);
      completeCurrentParagraph(location().start.offset, text().length, location().start.offset, []);
      addNextParagraph();
    };
  var peg$f14 = function(directives, block) {
      completeCurrentParagraph(location().start.offset, text().length, block.offset, directives);
      addNextParagraph();
    };
  var peg$f15 = function(block) {
      completeCurrentParagraph(location().start.offset, text().length, location().start.offset, []);
      addNextParagraph();
    };
  var peg$f16 = function() {
      return {
        offset: location().start.offset,
        length: text().length
      }
    };
  var peg$f17 = function(fp) {
      addPlaceholder(location().start.offset, text().length, fp.directives, fp.field.name, fp.field.label)
    };
  var peg$f18 = function(sc) {
      addPlaceholder(sc.offset, sc.length, [sc.controlDirective])
    };
  var peg$f19 = function() {
      if(text().trim().length > 0){
        currentParagraph().hasText = true;
      }
    };
  var peg$f20 = function() { return text(); };
  var peg$f21 = function(cd) {
    return {
      offset: location().start.offset,
      length: text().length,
      controlDirective: cd
    }
  };
  var peg$f22 = function(directives, field) {
      return {
        directives:directives, 
        field:field
      } 
    };
  var peg$f23 = function(field) {
      return {
       directives:[], 
       field:field
      } 
    };
  var peg$f24 = function(label, name) {
    return {
      name: name,
      label: label
    }
  };
  var peg$f25 = function() {
      return text();
    };
  var peg$f26 = function(firstChar, otherChars) {
    return text();
  };
  var peg$f27 = function(head, tail) {
    return tail.reduce(function(all, current){
      return all.concat(current[1]);
    }, head);
  };
  var peg$f28 = function(d, d2) { return d2 };
  var peg$f29 = function(d, ds) {
    return [d].concat(ds);
  };
  var peg$f30 = function() { return []; };
  var peg$f31 = function(d, c) {
    d.condition = c;
    return d;
  };
  var peg$f32 = function(head, tail) {
    return tail.reduce(function(all, current){
      return all.concat(current[1]);
    }, head);
  };
  var peg$f33 = function(d, d2) { return d2 };
  var peg$f34 = function(d, ds) { return [d].concat(ds); };
  var peg$f35 = function() { return []; };
  var peg$f36 = function(d, c) {
    d.condition = c;
    return d;
  };
  var peg$f37 = function() { return text() };
  var peg$f38 = function(c) {
  return c.trim();
};
  var peg$f39 = function() {
   return {
     type: "STYLE",
     params: [{name:"width", value:text()}]
   }
 };
  var peg$f40 = function(p1, p) { return p};
  var peg$f41 = function(p1, ps) {
   return {
     type: "STYLE",
     params: [p1].concat(ps)
   }
 };
  var peg$f42 = function(styling) { return styling };
  var peg$f43 = function(namespace, control, ps) { return ps};
  var peg$f44 = function(namespace, control, params) {
   if(!namespace && control === "auto") {
     error("The 'auto' control directive requires at least one parameter");
   }

   return {
     type: "CONTROL",
     controlNamespace: namespace || "",
     controlName: control,
     controlFullName: namespace? namespace+":"+control : control,
     params: params
   }
 };
  var peg$f45 = function(first, p) { return p };
  var peg$f46 = function(first, params) {
   return {
     type: "CONTROL",
     params: [first].concat(params)
   }
 };
  var peg$f47 = function(first, p) { return p };
  var peg$f48 = function(first, params) {
   return {
     type: "CONTROL",
     params: [first].concat(params)
   }
 };
  var peg$f49 = function(firstTag, tags) { return tags };
  var peg$f50 = function(firstTag, additionalTags) {
    const tags = {}
    
    for (const tag of [firstTag].concat(additionalTags)) {
      tags[tag.name] = tag.value ?? true
    }

    return {
      type: "TAGS",
      tags
    }
  };
  var peg$f51 = function(namespace) { return namespace };
  var peg$f52 = function(characters) {
    return characters.join('');
  };
  var peg$f53 = function(i, fr) { return { name:i, value:fr.value, field:fr.field, path:fr.path };  };
  var peg$f54 = function(i, v) { return { name:i, value:v };  };
  var peg$f55 = function(i, params) { return { name:i, value:params || {} }; };
  var peg$f56 = function(first, p) { return p };
  var peg$f57 = function(first, rest) {
    var parameters = {}

    for (var parameter of [first].concat(rest)) {
      parameters[parameter.name] = parameter.value
    }

    return parameters
  };
  var peg$f58 = function(i, fr) { return { name:i, value:fr.value, field:fr.field};  };
  var peg$f59 = function(i, v) { return { name:i, value:v };  };
  var peg$f60 = function(i) { return { name:i, value:true }; };
  var peg$f61 = function(i) { return {name:i, value:true}; };
  var peg$f62 = function(i) { return i };
  var peg$f63 = function(initialCharacter, otherCharacters) { return initialCharacter+otherCharacters.join(''); };
  var peg$f64 = function(firstTag, f) { return f};
  var peg$f65 = function(firstTag, additionalTags) {
    var tags = [firstTag].concat(additionalTags)
    var tagsResult = {}
    var tagsMeta = []

    for (var tag of tags) {
      if (tag.type === 'FIELD_CONDITION') {
        tagsResult._fieldCondition = tag.condition;
        continue;
      } else if (tag.condition) {
        setTagValue(tagsResult, tag.name, { value: tag.value == null ? true : tag.value, condition: tag.condition })
      } else {
        setTagValue(tagsResult, tag.name, tag.value == null ? true : tag.value)
      }
      // Store metadata for hint checking
      tagsMeta.push({
        name: tag.name,
        offset: tag.offset
      })
    }

    // Return both tags and metadata
    tagsResult._tagsMeta = tagsMeta
    return tagsResult
  };
  var peg$f66 = function(c) {
    return {
      type: 'FIELD_CONDITION',
      condition: c
    }
  };
  var peg$f67 = function(t, c) {
    return {
      name: t.name,
      value: t.value,
      condition: c,
      offset: t.offset
    }
  };
  var peg$f68 = function(cond) { return cond };
  var peg$f69 = function() { return ">" };
  var peg$f70 = function() { return ">=" };
  var peg$f71 = function(char) { return char };
  var peg$f72 = function(parts) {
    return parts.join('').trim()
  };
  var peg$f73 = function(i, params) {
    return { name: i.name, value: params || {}, offset: i.offset }
  };
  var peg$f74 = function(first, p) { return p };
  var peg$f75 = function(first, rest) {
    var parameters = {}

    for (var parameter of [first].concat(rest)) {
      parameters[parameter.name] = parameter.value
    }

    return parameters
  };
  var peg$f76 = function(i, fr) { return { name:i, value:fr.value, field:fr.field};  };
  var peg$f77 = function(i, v) { return { name:i, value:v };  };
  var peg$f78 = function(i) { return { name:i, value:true }; };
  var peg$f79 = function(i, v) {
    return { name: i.name, value: v, offset: i.offset }
  };
  var peg$f80 = function(i) {
    return { name: i.name, value: true, offset: i.offset }
  };
  var peg$f81 = function(i) {
    return { name: i, offset: location().start.offset }
  };
  var peg$f82 = function(initialCharacter, otherCharacters) { return initialCharacter+otherCharacters.join(''); };
  var peg$f83 = function(chars) { return chars.join(''); };
  var peg$f84 = function(chars) { return chars.join(''); };
  var peg$f85 = function(chars) { return chars.join(''); };
  var peg$f86 = function(chars) {
    return chars.join('').replace(/\\"/g, '"');
  };
  var peg$f87 = function(chars) {
    return chars.join('').replace(/\\'/g, "'");
  };
  var peg$f88 = function(first, s) { return s };
  var peg$f89 = function(first, rest) {
    var path = [first].concat(rest)
    var field = path[path.length - 1]

    if (path.length === 1) {
      return { value: text(), field: field, path: path }
    }

    var relations = path.slice(0, -1)
    var invalid = relations.filter(function(segment) { return !/^[A-Z]/.test(segment) })

    if (invalid.length === 0) {
      return { value: text(), field: field, path: path }
    }

    var start = location().start.offset
    var suggestion = '[' + relations.map(function(segment) { return segment[0].toUpperCase() + segment.slice(1) }).join('.') + '.' + field + ']'

    // The rule can run more than once for the same text while the parser backtracks
    var known = result.hints.some(function(hint) {
      return hint.type === 'invalid-field-reference' && hint.range.from === start
    })

    if (!known) {
      result.hints.push({
        type: 'invalid-field-reference',
        tag: text(),
        field: field,
        suggestion: suggestion,
        message: "Field reference '" + text() + "' needs capitalised Relation names before the field, e.g. '" + suggestion + "'. It is passed on as plain text.",
        range: { from: start, to: start + text().length }
      })
    }

    return { value: text() }
  };
  var peg$f90 = function(directives, typeDef) {
      typeDef.spec.defaultDirectives = {};
      applyDirectives(typeDef.spec.defaultDirectives, directives);
      return typeDef;
    };
  var peg$f91 = function(directives, typeDef) {
      typeDef.spec.defaultDirectives = {};
      applyDirectives(typeDef.spec.defaultDirectives, directives);
      return typeDef;
    };
  var peg$f92 = function(fieldName, spec) {
      return {
        offset: location().start.offset,
        length: text().length,
        fieldName: fieldName,
        spec: spec
      };
    };
  var peg$f93 = function(typeref, cardinality, tags) { return tags };
  var peg$f94 = function(typeref, cardinality, tagGroups, formula, help, cont, settings) {
      if (formula && help) {
        error('Quick help cannot follow a formula. Use <help="..."> before the formula instead.');
      }

      if (formula && cont && cont.formula) {
        error('Formula is defined more than once.');
      }

      var allTagGroups = (tagGroups || []).concat(cont?.tagGroups || []);
      var tags = mergeTagGroups(allTagGroups);
      var fieldCondition = tags._fieldCondition;
      delete tags._fieldCondition;

      var result = {
        required: tags && tags.required === true,
        cardinality: cardinality,
        condition: fieldCondition,
        tags: tags || {},
        settingsText: settings || {}
      }
      
      var effectiveFormula = formula || cont?.formula;

      if (effectiveFormula) {
        result.settingsText.formula = effectiveFormula;
      }
      
      if (help && !result.help) {
        result.help = help;
      }
      
      if (!typeref) {
        //result.typeReference = "string";
      }
      else if(typeref.quickSyntax) {
        result.typeReference = 'QUICKSYNTAXTYPE';
        result.quickSyntaxText = typeref.quickSyntax;
      }
      else {
        result.typeReference = typeref.toLowerCase()
      }
      
      return result;
    };
  var peg$f95 = function(settings) {
    var result = {
      settingsText: settings
    }
    
    return result;
  };
  var peg$f96 = function(lines) {
    var result = {
      tagGroups: [],
      formula: null
    };

    for (var line of lines) {
      if (line.tagGroups) {
        result.tagGroups = result.tagGroups.concat(line.tagGroups);
      }

      if (line.formula) {
        if (result.formula) {
          error('Formula is defined more than once.');
        }

        result.formula = line.formula;
      }
    }

    return result;
  };
  var peg$f97 = function(first, t) { return t };
  var peg$f98 = function(first, rest) { return { tagGroups: [first].concat(rest) } };
  var peg$f99 = function(formula) { return { formula } };
  var peg$f100 = function() { return text() };
  var peg$f101 = function() { return text() };
  var peg$f102 = function() { return text() };
  var peg$f103 = function() { return text() };
  var peg$f104 = function() { return text() };
  var peg$f105 = function() { return text() };
  var peg$f106 = function() { return text() };
  var peg$f107 = function() { return text() };
  var peg$f108 = function() { return text() };
  var peg$f109 = function() { return text() };
  var peg$f110 = function() { return text() };
  var peg$f111 = function() { return text() };
  var peg$f112 = function() { return text() };
  var peg$f113 = function() { return text() };
  var peg$f114 = function() { return text() };
  var peg$f115 = function() { return text() };
  var peg$f116 = function() { return text() };
  var peg$f117 = function() { return text() };
  var peg$f118 = function() { return text() };
  var peg$f119 = function() { return text() };
  var peg$f120 = function() { 
   return {
     quickSyntax: text().trim()
   }
  };
  var peg$f121 = function(min, max) {
      var result = {
        max: max.toLowerCase()
      }
      
      if(min)
        result.min = min.toLowerCase();
        
      return result;
    };
  var peg$f122 = function(min, max) {
      var result = {
        min: min.toLowerCase()
      }
      
      if(max)
        result.max = max.toLowerCase();
        
      return result;
    };
  var peg$f123 = function(minmax) {
      return {
        min: minmax.toLowerCase(),
        max: minmax.toLowerCase()
      }
    };
  var peg$f124 = function(chars) { return chars.join('').trim() };
  var peg$f125 = function(chars) { return chars.join('').trim(); };
  var peg$f126 = function(allSettings) {
    var result = {};

    allSettings.forEach(function(setting){
      result[setting.label] = setting.text;
    });
    
    return result;
  };
  var peg$f127 = function(first, settings) { return settings};
  var peg$f128 = function(first, others) {
    return [first].concat(others)
  };
  var peg$f129 = function(first, settings) { return settings};
  var peg$f130 = function(first, others) {
    return [first].concat(others)
  };
  var peg$f131 = function(lines) {
    return {
      label: '$default',
      text: lines.join('\n')
    }
  };
  var peg$f132 = function(label, lines) {
    return {
      label: label,
      text: lines.join('\n').replace(/\s*$/, '')
    }
  };
  var peg$f133 = function(line) { return line ; };
  var peg$f134 = function(chars) {
      var line = chars.join('').trim();
      return line;
    };
  var peg$f135 = function(label, param) {
      if (param) {
        return label + "(" + param + ")";
      } else {
        return label;
      }
    };
  var peg$f136 = function(label) {
      return label;
    };
  var peg$f137 = function(sign, digits) { return text() };
  var peg$f138 = function(digits) { return text() };
  var peg$f139 = function(chars) { return (chars.join('').trim().length == 0) };
  var peg$f140 = function(chars) {
      var line = chars.join('');
      return line;
    };
  var peg$f141 = function(char) {
      return char
    };
  var peg$currPos = options.peg$currPos | 0;
  var peg$savedPos = peg$currPos;
  var peg$posDetailsCache = [{ line: 1, column: 1 }];
  var peg$maxFailPos = peg$currPos;
  var peg$maxFailExpected = options.peg$maxFailExpected || [];
  var peg$silentFails = options.peg$silentFails | 0;

  var peg$result;

  if (options.startRule) {
    if (!(options.startRule in peg$startRuleFunctions)) {
      throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
    }

    peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
  }

  function text() {
    return input.substring(peg$savedPos, peg$currPos);
  }

  function offset() {
    return peg$savedPos;
  }

  function range() {
    return {
      source: peg$source,
      start: peg$savedPos,
      end: peg$currPos
    };
  }

  function location() {
    return peg$computeLocation(peg$savedPos, peg$currPos);
  }

  function expected(description, location) {
    location = location !== undefined
      ? location
      : peg$computeLocation(peg$savedPos, peg$currPos);

    throw peg$buildStructuredError(
      [peg$otherExpectation(description)],
      input.substring(peg$savedPos, peg$currPos),
      location
    );
  }

  function error(message, location) {
    location = location !== undefined
      ? location
      : peg$computeLocation(peg$savedPos, peg$currPos);

    throw peg$buildSimpleError(message, location);
  }

  function peg$literalExpectation(text, ignoreCase) {
    return { type: "literal", text: text, ignoreCase: ignoreCase };
  }

  function peg$classExpectation(parts, inverted, ignoreCase) {
    return { type: "class", parts: parts, inverted: inverted, ignoreCase: ignoreCase };
  }

  function peg$anyExpectation() {
    return { type: "any" };
  }

  function peg$endExpectation() {
    return { type: "end" };
  }

  function peg$otherExpectation(description) {
    return { type: "other", description: description };
  }

  function peg$computePosDetails(pos) {
    var details = peg$posDetailsCache[pos];
    var p;

    if (details) {
      return details;
    } else {
      if (pos >= peg$posDetailsCache.length) {
        p = peg$posDetailsCache.length - 1;
      } else {
        p = pos;
        while (!peg$posDetailsCache[--p]) {}
      }

      details = peg$posDetailsCache[p];
      details = {
        line: details.line,
        column: details.column
      };

      while (p < pos) {
        if (input.charCodeAt(p) === 10) {
          details.line++;
          details.column = 1;
        } else {
          details.column++;
        }

        p++;
      }

      peg$posDetailsCache[pos] = details;

      return details;
    }
  }

  function peg$computeLocation(startPos, endPos, offset) {
    var startPosDetails = peg$computePosDetails(startPos);
    var endPosDetails = peg$computePosDetails(endPos);

    var res = {
      source: peg$source,
      start: {
        offset: startPos,
        line: startPosDetails.line,
        column: startPosDetails.column
      },
      end: {
        offset: endPos,
        line: endPosDetails.line,
        column: endPosDetails.column
      }
    };
    if (offset && peg$source && (typeof peg$source.offset === "function")) {
      res.start = peg$source.offset(res.start);
      res.end = peg$source.offset(res.end);
    }
    return res;
  }

  function peg$fail(expected) {
    if (peg$currPos < peg$maxFailPos) { return; }

    if (peg$currPos > peg$maxFailPos) {
      peg$maxFailPos = peg$currPos;
      peg$maxFailExpected = [];
    }

    peg$maxFailExpected.push(expected);
  }

  function peg$buildSimpleError(message, location) {
    return new peg$SyntaxError(message, null, null, location);
  }

  function peg$buildStructuredError(expected, found, location) {
    return new peg$SyntaxError(
      peg$SyntaxError.buildMessage(expected, found),
      expected,
      found,
      location
    );
  }

  function peg$parseStart() {
    var s0, s1;

    s0 = peg$currPos;
    s1 = peg$parse_FormDefinition();
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f0(s1);
    }
    s0 = s1;

    return s0;
  }

  function peg$parse_FormDefinition() {
    var s0, s1, s2, s3;

    s0 = peg$currPos;
    s1 = peg$parse_RootSectionDirectives();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$parse_DefinitionItem();
      if (s3 !== peg$FAILED) {
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$parse_DefinitionItem();
        }
      } else {
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f1(s1);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = [];
      s1 = peg$parse_DefinitionItem();
      if (s1 !== peg$FAILED) {
        while (s1 !== peg$FAILED) {
          s0.push(s1);
          s1 = peg$parse_DefinitionItem();
        }
      } else {
        s0 = peg$FAILED;
      }
    }

    return s0;
  }

  function peg$parse_RootSectionDirectives() {
    var s0, s1, s2, s3;

    s0 = peg$currPos;
    s1 = peg$parseSectionDirectives();
    if (s1 !== peg$FAILED) {
      s2 = peg$parseEOL();
      if (s2 !== peg$FAILED) {
        s3 = peg$parseEmptyLine();
        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f2(s1);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parse_DefinitionItem() {
    var s0, s1, s2, s3, s4;

    s0 = peg$currPos;
    s1 = peg$parseSectionDirectives();
    if (s1 !== peg$FAILED) {
      s2 = peg$parseEOL();
      if (s2 !== peg$FAILED) {
        s3 = peg$currPos;
        peg$silentFails++;
        s4 = peg$parseSection();
        peg$silentFails--;
        if (s4 !== peg$FAILED) {
          peg$currPos = s3;
          s3 = undefined;
        } else {
          s3 = peg$FAILED;
        }
        if (s3 !== peg$FAILED) {
          s4 = peg$parseSection();
          if (s4 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f3(s1, s4);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parse_StyledSection();
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$f4(s1);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parse_StyledTypeDefinition();
        if (s1 !== peg$FAILED) {
          s2 = peg$parseEmptyLine();
          if (s2 === peg$FAILED) {
            s2 = null;
          }
          peg$savedPos = s0;
          s0 = peg$f5(s1, s2);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          s1 = peg$parseEmptyLine();
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$f6();
          }
          s0 = s1;
          if (s0 === peg$FAILED) {
            s0 = peg$parse_StyledMarkupBlock();
          }
        }
      }
    }

    return s0;
  }

  function peg$parse_StyledSection() {
    var s0, s1, s2, s3;

    s0 = peg$currPos;
    s1 = peg$parseSectionDirectives();
    if (s1 !== peg$FAILED) {
      s2 = peg$parseLineTerminatorSequence();
      if (s2 !== peg$FAILED) {
        s3 = peg$parseSection();
        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f7(s1, s3);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseSection();
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$f8(s1);
      }
      s0 = s1;
    }

    return s0;
  }

  function peg$parseSection() {
    var s0;

    s0 = peg$parseSection1();
    if (s0 === peg$FAILED) {
      s0 = peg$parseSection2();
      if (s0 === peg$FAILED) {
        s0 = peg$parseSectionX();
      }
    }

    return s0;
  }

  function peg$parseSection1() {
    var s0, s1, s2, s3, s4, s5;

    s0 = peg$currPos;
    s1 = [];
    s2 = peg$parseLineCharacter();
    if (s2 !== peg$FAILED) {
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parseLineCharacter();
      }
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parseLineTerminator();
      if (s2 !== peg$FAILED) {
        if (input.substr(peg$currPos, 3) === peg$c0) {
          s3 = peg$c0;
          peg$currPos += 3;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e0); }
        }
        if (s3 !== peg$FAILED) {
          s4 = [];
          s5 = peg$parseLineCharacter();
          while (s5 !== peg$FAILED) {
            s4.push(s5);
            s5 = peg$parseLineCharacter();
          }
          s5 = peg$parseLineTerminator();
          if (s5 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f9(s1);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseSection2() {
    var s0, s1, s2, s3, s4, s5;

    s0 = peg$currPos;
    s1 = [];
    s2 = peg$parseLineCharacter();
    if (s2 !== peg$FAILED) {
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parseLineCharacter();
      }
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parseLineTerminator();
      if (s2 !== peg$FAILED) {
        if (input.substr(peg$currPos, 3) === peg$c1) {
          s3 = peg$c1;
          peg$currPos += 3;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e1); }
        }
        if (s3 !== peg$FAILED) {
          s4 = [];
          s5 = peg$parseLineCharacter();
          while (s5 !== peg$FAILED) {
            s4.push(s5);
            s5 = peg$parseLineCharacter();
          }
          s5 = peg$parseLineTerminator();
          if (s5 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f10(s1);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseSectionX() {
    var s0, s1, s2, s3;

    s0 = peg$currPos;
    s1 = [];
    if (input.charCodeAt(peg$currPos) === 35) {
      s2 = peg$c2;
      peg$currPos++;
    } else {
      s2 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e2); }
    }
    if (s2 !== peg$FAILED) {
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        if (input.charCodeAt(peg$currPos) === 35) {
          s2 = peg$c2;
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e2); }
        }
      }
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parseSectionXTitle();
      if (s2 === peg$FAILED) {
        s2 = null;
      }
      s3 = peg$parseEOL();
      if (s3 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f11(s1, s2);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseSectionXTitle() {
    var s0, s1, s2, s3;

    s0 = peg$currPos;
    s1 = [];
    s2 = peg$parseWhiteSpace();
    if (s2 !== peg$FAILED) {
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parseWhiteSpace();
      }
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$parseLineCharacter();
      if (s3 !== peg$FAILED) {
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$parseLineCharacter();
        }
      } else {
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f12(s2);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseSectionHeadingStart() {
    var s0;

    s0 = peg$parseSectionAtxHeadingStart();
    if (s0 === peg$FAILED) {
      s0 = peg$parseSectionSetextHeadingStart();
    }

    return s0;
  }

  function peg$parseSectionAtxHeadingStart() {
    var s0;

    if (input.charCodeAt(peg$currPos) === 35) {
      s0 = peg$c2;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e2); }
    }

    return s0;
  }

  function peg$parseSectionSetextHeadingStart() {
    var s0, s1, s2, s3, s4, s5;

    s0 = peg$currPos;
    s1 = [];
    s2 = peg$parseLineCharacter();
    if (s2 !== peg$FAILED) {
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parseLineCharacter();
      }
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parseLineTerminator();
      if (s2 !== peg$FAILED) {
        if (input.substr(peg$currPos, 3) === peg$c0) {
          s3 = peg$c0;
          peg$currPos += 3;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e0); }
        }
        if (s3 === peg$FAILED) {
          if (input.substr(peg$currPos, 3) === peg$c1) {
            s3 = peg$c1;
            peg$currPos += 3;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$e1); }
          }
        }
        if (s3 !== peg$FAILED) {
          s4 = [];
          s5 = peg$parseLineCharacter();
          while (s5 !== peg$FAILED) {
            s4.push(s5);
            s5 = peg$parseLineCharacter();
          }
          s5 = peg$parseLineTerminator();
          if (s5 !== peg$FAILED) {
            s1 = [s1, s2, s3, s4, s5];
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parse_StyledMarkupBlock() {
    var s0, s1, s2, s3, s4;

    s0 = peg$currPos;
    s1 = peg$parseFieldPosition();
    if (s1 !== peg$FAILED) {
      s2 = peg$parseEOL();
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f13(s1);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseSectionDirectives();
      if (s1 !== peg$FAILED) {
        s2 = peg$parseEOL();
        if (s2 !== peg$FAILED) {
          s3 = peg$currPos;
          peg$silentFails++;
          s4 = peg$parseSectionHeadingStart();
          peg$silentFails--;
          if (s4 === peg$FAILED) {
            s3 = undefined;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_MarkupBlock();
            if (s4 !== peg$FAILED) {
              peg$savedPos = s0;
              s0 = peg$f14(s1, s4);
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parse_MarkupBlock();
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$f15(s1);
        }
        s0 = s1;
      }
    }

    return s0;
  }

  function peg$parse_MarkupBlock() {
    var s0, s1, s2, s3, s4, s5, s6, s7;

    s0 = peg$currPos;
    s1 = [];
    s2 = peg$currPos;
    s3 = peg$currPos;
    peg$silentFails++;
    s4 = peg$parseTypeDefinition();
    peg$silentFails--;
    if (s4 === peg$FAILED) {
      s3 = undefined;
    } else {
      peg$currPos = s3;
      s3 = peg$FAILED;
    }
    if (s3 !== peg$FAILED) {
      s4 = peg$parse_MarkupSpan();
      if (s4 !== peg$FAILED) {
        s5 = peg$currPos;
        s6 = peg$currPos;
        peg$silentFails++;
        s7 = peg$parseEOB();
        peg$silentFails--;
        if (s7 === peg$FAILED) {
          s6 = undefined;
        } else {
          peg$currPos = s6;
          s6 = peg$FAILED;
        }
        if (s6 !== peg$FAILED) {
          s7 = peg$parseEOL();
          if (s7 !== peg$FAILED) {
            s6 = [s6, s7];
            s5 = s6;
          } else {
            peg$currPos = s5;
            s5 = peg$FAILED;
          }
        } else {
          peg$currPos = s5;
          s5 = peg$FAILED;
        }
        if (s5 === peg$FAILED) {
          s5 = null;
        }
        s3 = [s3, s4, s5];
        s2 = s3;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
    } else {
      peg$currPos = s2;
      s2 = peg$FAILED;
    }
    if (s2 !== peg$FAILED) {
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$currPos;
        s3 = peg$currPos;
        peg$silentFails++;
        s4 = peg$parseTypeDefinition();
        peg$silentFails--;
        if (s4 === peg$FAILED) {
          s3 = undefined;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
        if (s3 !== peg$FAILED) {
          s4 = peg$parse_MarkupSpan();
          if (s4 !== peg$FAILED) {
            s5 = peg$currPos;
            s6 = peg$currPos;
            peg$silentFails++;
            s7 = peg$parseEOB();
            peg$silentFails--;
            if (s7 === peg$FAILED) {
              s6 = undefined;
            } else {
              peg$currPos = s6;
              s6 = peg$FAILED;
            }
            if (s6 !== peg$FAILED) {
              s7 = peg$parseEOL();
              if (s7 !== peg$FAILED) {
                s6 = [s6, s7];
                s5 = s6;
              } else {
                peg$currPos = s5;
                s5 = peg$FAILED;
              }
            } else {
              peg$currPos = s5;
              s5 = peg$FAILED;
            }
            if (s5 === peg$FAILED) {
              s5 = null;
            }
            s3 = [s3, s4, s5];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      }
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f16();
    }
    s0 = s1;

    return s0;
  }

  function peg$parse_MarkupSpan() {
    var s0, s1;

    s0 = peg$currPos;
    s1 = peg$parseFieldPosition();
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f17(s1);
    }
    s0 = s1;
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseStandaloneControl();
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$f18(s1);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parseTextSpan();
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$f19();
        }
        s0 = s1;
      }
    }

    return s0;
  }

  function peg$parseTextSpan() {
    var s0, s1, s2, s3, s4, s5;

    s0 = peg$currPos;
    s1 = [];
    s2 = peg$currPos;
    s3 = peg$currPos;
    peg$silentFails++;
    s4 = peg$parseFieldPosition();
    peg$silentFails--;
    if (s4 === peg$FAILED) {
      s3 = undefined;
    } else {
      peg$currPos = s3;
      s3 = peg$FAILED;
    }
    if (s3 !== peg$FAILED) {
      s4 = peg$currPos;
      peg$silentFails++;
      s5 = peg$parseStandaloneControl();
      peg$silentFails--;
      if (s5 === peg$FAILED) {
        s4 = undefined;
      } else {
        peg$currPos = s4;
        s4 = peg$FAILED;
      }
      if (s4 !== peg$FAILED) {
        s5 = peg$parseLineCharacter();
        if (s5 !== peg$FAILED) {
          s3 = [s3, s4, s5];
          s2 = s3;
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
    } else {
      peg$currPos = s2;
      s2 = peg$FAILED;
    }
    if (s2 !== peg$FAILED) {
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$currPos;
        s3 = peg$currPos;
        peg$silentFails++;
        s4 = peg$parseFieldPosition();
        peg$silentFails--;
        if (s4 === peg$FAILED) {
          s3 = undefined;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
        if (s3 !== peg$FAILED) {
          s4 = peg$currPos;
          peg$silentFails++;
          s5 = peg$parseStandaloneControl();
          peg$silentFails--;
          if (s5 === peg$FAILED) {
            s4 = undefined;
          } else {
            peg$currPos = s4;
            s4 = peg$FAILED;
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parseLineCharacter();
            if (s5 !== peg$FAILED) {
              s3 = [s3, s4, s5];
              s2 = s3;
            } else {
              peg$currPos = s2;
              s2 = peg$FAILED;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      }
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f20();
    }
    s0 = s1;

    return s0;
  }

  function peg$parseStandaloneControl() {
    var s0, s1, s2, s3, s4, s5, s6, s7;

    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 123) {
      s1 = peg$c3;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e3); }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseControlDirective();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        if (input.charCodeAt(peg$currPos) === 125) {
          s5 = peg$c4;
          peg$currPos++;
        } else {
          s5 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e4); }
        }
        if (s5 !== peg$FAILED) {
          s6 = peg$currPos;
          peg$silentFails++;
          s7 = peg$parseEOL();
          peg$silentFails--;
          if (s7 !== peg$FAILED) {
            peg$currPos = s6;
            s6 = undefined;
          } else {
            s6 = peg$FAILED;
          }
          if (s6 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f21(s3);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseFieldPosition() {
    var s0, s1, s2, s3;

    s0 = peg$currPos;
    s1 = peg$parseFieldDirectives();
    if (s1 !== peg$FAILED) {
      s2 = peg$parseEOL();
      if (s2 === peg$FAILED) {
        s2 = null;
      }
      s3 = peg$parseField();
      if (s3 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f22(s1, s3);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseField();
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$f23(s1);
      }
      s0 = s1;
    }

    return s0;
  }

  function peg$parseField() {
    var s0, s1, s2, s3, s4, s5;

    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 91) {
      s1 = peg$c5;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e5); }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parseFieldLabel();
      if (input.substr(peg$currPos, 2) === peg$c6) {
        s3 = peg$c6;
        peg$currPos += 2;
      } else {
        s3 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e6); }
      }
      if (s3 !== peg$FAILED) {
        s4 = peg$parseFieldName();
        if (s4 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 93) {
            s5 = peg$c7;
            peg$currPos++;
          } else {
            s5 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$e7); }
          }
          if (s5 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f24(s2, s4);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseFieldLabel() {
    var s0, s1, s2, s3, s4, s5;

    s0 = peg$currPos;
    s1 = [];
    s2 = peg$currPos;
    s3 = peg$currPos;
    peg$silentFails++;
    if (input.charCodeAt(peg$currPos) === 91) {
      s4 = peg$c5;
      peg$currPos++;
    } else {
      s4 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e5); }
    }
    peg$silentFails--;
    if (s4 === peg$FAILED) {
      s3 = undefined;
    } else {
      peg$currPos = s3;
      s3 = peg$FAILED;
    }
    if (s3 !== peg$FAILED) {
      s4 = peg$currPos;
      peg$silentFails++;
      if (input.charCodeAt(peg$currPos) === 93) {
        s5 = peg$c7;
        peg$currPos++;
      } else {
        s5 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e7); }
      }
      peg$silentFails--;
      if (s5 === peg$FAILED) {
        s4 = undefined;
      } else {
        peg$currPos = s4;
        s4 = peg$FAILED;
      }
      if (s4 !== peg$FAILED) {
        s5 = peg$parseLineCharacter();
        if (s5 !== peg$FAILED) {
          s3 = [s3, s4, s5];
          s2 = s3;
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
    } else {
      peg$currPos = s2;
      s2 = peg$FAILED;
    }
    while (s2 !== peg$FAILED) {
      s1.push(s2);
      s2 = peg$currPos;
      s3 = peg$currPos;
      peg$silentFails++;
      if (input.charCodeAt(peg$currPos) === 91) {
        s4 = peg$c5;
        peg$currPos++;
      } else {
        s4 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e5); }
      }
      peg$silentFails--;
      if (s4 === peg$FAILED) {
        s3 = undefined;
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      if (s3 !== peg$FAILED) {
        s4 = peg$currPos;
        peg$silentFails++;
        if (input.charCodeAt(peg$currPos) === 93) {
          s5 = peg$c7;
          peg$currPos++;
        } else {
          s5 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e7); }
        }
        peg$silentFails--;
        if (s5 === peg$FAILED) {
          s4 = undefined;
        } else {
          peg$currPos = s4;
          s4 = peg$FAILED;
        }
        if (s4 !== peg$FAILED) {
          s5 = peg$parseLineCharacter();
          if (s5 !== peg$FAILED) {
            s3 = [s3, s4, s5];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
    }
    peg$savedPos = s0;
    s1 = peg$f25();
    s0 = s1;

    return s0;
  }

  function peg$parseFieldName() {
    var s0, s1, s2, s3;

    s0 = peg$currPos;
    s1 = input.charAt(peg$currPos);
    if (peg$r0.test(s1)) {
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e8); }
    }
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = input.charAt(peg$currPos);
      if (peg$r1.test(s3)) {
        peg$currPos++;
      } else {
        s3 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e9); }
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = input.charAt(peg$currPos);
        if (peg$r1.test(s3)) {
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e9); }
        }
      }
      peg$savedPos = s0;
      s0 = peg$f26(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseFieldDirectives() {
    var s0, s1, s2, s3, s4, s5;

    s0 = peg$currPos;
    s1 = peg$parseFieldMultiDirective();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parseFieldDirectiveSeparator();
      if (s4 !== peg$FAILED) {
        s5 = peg$parseFieldMultiDirective();
        if (s5 !== peg$FAILED) {
          s4 = [s4, s5];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parseFieldDirectiveSeparator();
        if (s4 !== peg$FAILED) {
          s5 = peg$parseFieldMultiDirective();
          if (s5 !== peg$FAILED) {
            s4 = [s4, s5];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f27(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseFieldMultiDirective() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9;

    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 123) {
      s1 = peg$c3;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e3); }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseConditionalFieldDirective();
      if (s3 !== peg$FAILED) {
        s4 = [];
        s5 = peg$currPos;
        s6 = peg$parse__();
        if (input.charCodeAt(peg$currPos) === 124) {
          s7 = peg$c8;
          peg$currPos++;
        } else {
          s7 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e10); }
        }
        if (s7 !== peg$FAILED) {
          s8 = peg$parse__();
          s9 = peg$parseConditionalFieldDirective();
          if (s9 !== peg$FAILED) {
            peg$savedPos = s5;
            s5 = peg$f28(s3, s9);
          } else {
            peg$currPos = s5;
            s5 = peg$FAILED;
          }
        } else {
          peg$currPos = s5;
          s5 = peg$FAILED;
        }
        while (s5 !== peg$FAILED) {
          s4.push(s5);
          s5 = peg$currPos;
          s6 = peg$parse__();
          if (input.charCodeAt(peg$currPos) === 124) {
            s7 = peg$c8;
            peg$currPos++;
          } else {
            s7 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$e10); }
          }
          if (s7 !== peg$FAILED) {
            s8 = peg$parse__();
            s9 = peg$parseConditionalFieldDirective();
            if (s9 !== peg$FAILED) {
              peg$savedPos = s5;
              s5 = peg$f28(s3, s9);
            } else {
              peg$currPos = s5;
              s5 = peg$FAILED;
            }
          } else {
            peg$currPos = s5;
            s5 = peg$FAILED;
          }
        }
        s5 = peg$parse__();
        if (input.charCodeAt(peg$currPos) === 125) {
          s6 = peg$c4;
          peg$currPos++;
        } else {
          s6 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e4); }
        }
        if (s6 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f29(s3, s4);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 123) {
        s1 = peg$c3;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e3); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse__();
        if (input.charCodeAt(peg$currPos) === 125) {
          s3 = peg$c4;
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e4); }
        }
        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f30();
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }

    return s0;
  }

  function peg$parseConditionalFieldDirective() {
    var s0, s1, s2, s3;

    s0 = peg$currPos;
    s1 = peg$parseFieldDirective();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$parseWhiteSpace();
      if (s3 !== peg$FAILED) {
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$parseWhiteSpace();
        }
      } else {
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parseCondition();
        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f31(s1, s3);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$parseFieldDirective();
    }

    return s0;
  }

  function peg$parseSectionDirectives() {
    var s0, s1, s2, s3, s4, s5;

    s0 = peg$currPos;
    s1 = peg$parseSectionMultiDirective();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parseSectionDirectiveSeparator();
      if (s4 !== peg$FAILED) {
        s5 = peg$parseSectionMultiDirective();
        if (s5 !== peg$FAILED) {
          s4 = [s4, s5];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parseSectionDirectiveSeparator();
        if (s4 !== peg$FAILED) {
          s5 = peg$parseSectionMultiDirective();
          if (s5 !== peg$FAILED) {
            s4 = [s4, s5];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f32(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseSectionMultiDirective() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9;

    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 123) {
      s1 = peg$c3;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e3); }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseConditionalSectionDirective();
      if (s3 !== peg$FAILED) {
        s4 = [];
        s5 = peg$currPos;
        s6 = peg$parse__();
        if (input.charCodeAt(peg$currPos) === 124) {
          s7 = peg$c8;
          peg$currPos++;
        } else {
          s7 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e10); }
        }
        if (s7 !== peg$FAILED) {
          s8 = peg$parse__();
          s9 = peg$parseConditionalSectionDirective();
          if (s9 !== peg$FAILED) {
            peg$savedPos = s5;
            s5 = peg$f33(s3, s9);
          } else {
            peg$currPos = s5;
            s5 = peg$FAILED;
          }
        } else {
          peg$currPos = s5;
          s5 = peg$FAILED;
        }
        while (s5 !== peg$FAILED) {
          s4.push(s5);
          s5 = peg$currPos;
          s6 = peg$parse__();
          if (input.charCodeAt(peg$currPos) === 124) {
            s7 = peg$c8;
            peg$currPos++;
          } else {
            s7 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$e10); }
          }
          if (s7 !== peg$FAILED) {
            s8 = peg$parse__();
            s9 = peg$parseConditionalSectionDirective();
            if (s9 !== peg$FAILED) {
              peg$savedPos = s5;
              s5 = peg$f33(s3, s9);
            } else {
              peg$currPos = s5;
              s5 = peg$FAILED;
            }
          } else {
            peg$currPos = s5;
            s5 = peg$FAILED;
          }
        }
        s5 = peg$parse__();
        if (input.charCodeAt(peg$currPos) === 125) {
          s6 = peg$c4;
          peg$currPos++;
        } else {
          s6 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e4); }
        }
        if (s6 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f34(s3, s4);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 123) {
        s1 = peg$c3;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e3); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse__();
        if (input.charCodeAt(peg$currPos) === 125) {
          s3 = peg$c4;
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e4); }
        }
        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f35();
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }

    return s0;
  }

  function peg$parseConditionalSectionDirective() {
    var s0, s1, s2, s3;

    s0 = peg$currPos;
    s1 = peg$parseSectionDirective();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$parseWhiteSpace();
      if (s3 !== peg$FAILED) {
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$parseWhiteSpace();
        }
      } else {
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parseCondition();
        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f36(s1, s3);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$parseSectionDirective();
    }

    return s0;
  }

  function peg$parseCondition() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8;

    s0 = peg$currPos;
    if (input.substr(peg$currPos, 2) === peg$c9) {
      s1 = peg$c9;
      peg$currPos += 2;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e11); }
    }
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$parseWhiteSpace();
      if (s3 !== peg$FAILED) {
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$parseWhiteSpace();
        }
      } else {
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$currPos;
        s4 = [];
        if (input.substr(peg$currPos, 2) === peg$c10) {
          s5 = peg$c10;
          peg$currPos += 2;
        } else {
          s5 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e12); }
        }
        if (s5 === peg$FAILED) {
          s5 = peg$currPos;
          s6 = peg$currPos;
          peg$silentFails++;
          if (input.charCodeAt(peg$currPos) === 125) {
            s7 = peg$c4;
            peg$currPos++;
          } else {
            s7 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$e4); }
          }
          peg$silentFails--;
          if (s7 === peg$FAILED) {
            s6 = undefined;
          } else {
            peg$currPos = s6;
            s6 = peg$FAILED;
          }
          if (s6 !== peg$FAILED) {
            s7 = peg$currPos;
            peg$silentFails++;
            if (input.charCodeAt(peg$currPos) === 124) {
              s8 = peg$c8;
              peg$currPos++;
            } else {
              s8 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$e10); }
            }
            peg$silentFails--;
            if (s8 === peg$FAILED) {
              s7 = undefined;
            } else {
              peg$currPos = s7;
              s7 = peg$FAILED;
            }
            if (s7 !== peg$FAILED) {
              s8 = peg$parseLineCharacter();
              if (s8 !== peg$FAILED) {
                s6 = [s6, s7, s8];
                s5 = s6;
              } else {
                peg$currPos = s5;
                s5 = peg$FAILED;
              }
            } else {
              peg$currPos = s5;
              s5 = peg$FAILED;
            }
          } else {
            peg$currPos = s5;
            s5 = peg$FAILED;
          }
        }
        if (s5 !== peg$FAILED) {
          while (s5 !== peg$FAILED) {
            s4.push(s5);
            if (input.substr(peg$currPos, 2) === peg$c10) {
              s5 = peg$c10;
              peg$currPos += 2;
            } else {
              s5 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$e12); }
            }
            if (s5 === peg$FAILED) {
              s5 = peg$currPos;
              s6 = peg$currPos;
              peg$silentFails++;
              if (input.charCodeAt(peg$currPos) === 125) {
                s7 = peg$c4;
                peg$currPos++;
              } else {
                s7 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$e4); }
              }
              peg$silentFails--;
              if (s7 === peg$FAILED) {
                s6 = undefined;
              } else {
                peg$currPos = s6;
                s6 = peg$FAILED;
              }
              if (s6 !== peg$FAILED) {
                s7 = peg$currPos;
                peg$silentFails++;
                if (input.charCodeAt(peg$currPos) === 124) {
                  s8 = peg$c8;
                  peg$currPos++;
                } else {
                  s8 = peg$FAILED;
                  if (peg$silentFails === 0) { peg$fail(peg$e10); }
                }
                peg$silentFails--;
                if (s8 === peg$FAILED) {
                  s7 = undefined;
                } else {
                  peg$currPos = s7;
                  s7 = peg$FAILED;
                }
                if (s7 !== peg$FAILED) {
                  s8 = peg$parseLineCharacter();
                  if (s8 !== peg$FAILED) {
                    s6 = [s6, s7, s8];
                    s5 = s6;
                  } else {
                    peg$currPos = s5;
                    s5 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s5;
                  s5 = peg$FAILED;
                }
              } else {
                peg$currPos = s5;
                s5 = peg$FAILED;
              }
            }
          }
        } else {
          s4 = peg$FAILED;
        }
        if (s4 !== peg$FAILED) {
          peg$savedPos = s3;
          s4 = peg$f37();
        }
        s3 = s4;
        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f38(s3);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseSectionDirective() {
    var s0;

    s0 = peg$parseStylingDirective();
    if (s0 === peg$FAILED) {
      s0 = peg$parseWidthDirective();
      if (s0 === peg$FAILED) {
        s0 = peg$parseTagsDirective();
      }
    }

    return s0;
  }

  function peg$parseFieldDirective() {
    var s0;

    s0 = peg$parseStylingDirective();
    if (s0 === peg$FAILED) {
      s0 = peg$parseWidthDirective();
      if (s0 === peg$FAILED) {
        s0 = peg$parseAutoControlParametersDirective();
        if (s0 === peg$FAILED) {
          s0 = peg$parseControlDirective();
          if (s0 === peg$FAILED) {
            s0 = peg$parseAnonymousControlParametersDirective();
          }
        }
      }
    }

    return s0;
  }

  function peg$parseWidthDirective() {
    var s0, s1, s2, s3;

    s0 = peg$currPos;
    s1 = peg$parseUnsignedNumber();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseUnitOfWidth();
      if (s3 === peg$FAILED) {
        s3 = null;
      }
      peg$savedPos = s0;
      s0 = peg$f39();
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseStylingDirective() {
    var s0, s1, s2, s3, s4, s5, s6;

    s0 = peg$currPos;
    s1 = peg$currPos;
    peg$silentFails++;
    s2 = peg$parseCondition();
    peg$silentFails--;
    if (s2 === peg$FAILED) {
      s1 = undefined;
    } else {
      peg$currPos = s1;
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parseStylingParameter();
      if (s2 !== peg$FAILED) {
        s3 = [];
        s4 = peg$currPos;
        s5 = [];
        s6 = peg$parseWhiteSpace();
        if (s6 !== peg$FAILED) {
          while (s6 !== peg$FAILED) {
            s5.push(s6);
            s6 = peg$parseWhiteSpace();
          }
        } else {
          s5 = peg$FAILED;
        }
        if (s5 !== peg$FAILED) {
          s6 = peg$parseStylingParameter();
          if (s6 !== peg$FAILED) {
            peg$savedPos = s4;
            s4 = peg$f40(s2, s6);
          } else {
            peg$currPos = s4;
            s4 = peg$FAILED;
          }
        } else {
          peg$currPos = s4;
          s4 = peg$FAILED;
        }
        while (s4 !== peg$FAILED) {
          s3.push(s4);
          s4 = peg$currPos;
          s5 = [];
          s6 = peg$parseWhiteSpace();
          if (s6 !== peg$FAILED) {
            while (s6 !== peg$FAILED) {
              s5.push(s6);
              s6 = peg$parseWhiteSpace();
            }
          } else {
            s5 = peg$FAILED;
          }
          if (s5 !== peg$FAILED) {
            s6 = peg$parseStylingParameter();
            if (s6 !== peg$FAILED) {
              peg$savedPos = s4;
              s4 = peg$f40(s2, s6);
            } else {
              peg$currPos = s4;
              s4 = peg$FAILED;
            }
          } else {
            peg$currPos = s4;
            s4 = peg$FAILED;
          }
        }
        peg$savedPos = s0;
        s0 = peg$f41(s2, s3);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseStylingParameter() {
    var s0, s1, s2, s3;

    s0 = peg$currPos;
    if (input.substr(peg$currPos, 8) === peg$c11) {
      s1 = peg$c11;
      peg$currPos += 8;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e13); }
    }
    if (s1 === peg$FAILED) {
      if (input.substr(peg$currPos, 8) === peg$c12) {
        s1 = peg$c12;
        peg$currPos += 8;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e14); }
      }
      if (s1 === peg$FAILED) {
        if (input.substr(peg$currPos, 6) === peg$c13) {
          s1 = peg$c13;
          peg$currPos += 6;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e15); }
        }
        if (s1 === peg$FAILED) {
          if (input.substr(peg$currPos, 4) === peg$c14) {
            s1 = peg$c14;
            peg$currPos += 4;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$e16); }
          }
          if (s1 === peg$FAILED) {
            if (input.substr(peg$currPos, 4) === peg$c15) {
              s1 = peg$c15;
              peg$currPos += 4;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$e17); }
            }
          }
        }
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseWhiteSpace();
      if (s3 === peg$FAILED) {
        s3 = input.charAt(peg$currPos);
        if (peg$r2.test(s3)) {
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e18); }
        }
      }
      peg$silentFails--;
      if (s3 !== peg$FAILED) {
        peg$currPos = s2;
        s2 = undefined;
      } else {
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f42(s1);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseControlDirective() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8;

    s0 = peg$currPos;
    s1 = peg$currPos;
    peg$silentFails++;
    s2 = peg$parseCondition();
    peg$silentFails--;
    if (s2 === peg$FAILED) {
      s1 = undefined;
    } else {
      peg$currPos = s1;
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parseControlNamespace();
      if (s2 === peg$FAILED) {
        s2 = null;
      }
      s3 = peg$parseIdentifierAllowingDashesAndHyphens();
      if (s3 !== peg$FAILED) {
        s4 = peg$currPos;
        peg$silentFails++;
        s5 = peg$currPos;
        s6 = peg$parse__();
        if (input.charCodeAt(peg$currPos) === 61) {
          s7 = peg$c16;
          peg$currPos++;
        } else {
          s7 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e19); }
        }
        if (s7 !== peg$FAILED) {
          s6 = [s6, s7];
          s5 = s6;
        } else {
          peg$currPos = s5;
          s5 = peg$FAILED;
        }
        peg$silentFails--;
        if (s5 === peg$FAILED) {
          s4 = undefined;
        } else {
          peg$currPos = s4;
          s4 = peg$FAILED;
        }
        if (s4 !== peg$FAILED) {
          s5 = [];
          s6 = peg$currPos;
          s7 = [];
          s8 = peg$parseWhiteSpace();
          if (s8 !== peg$FAILED) {
            while (s8 !== peg$FAILED) {
              s7.push(s8);
              s8 = peg$parseWhiteSpace();
            }
          } else {
            s7 = peg$FAILED;
          }
          if (s7 !== peg$FAILED) {
            s8 = peg$parseParameter();
            if (s8 === peg$FAILED) {
              s8 = peg$parseObjectParameter();
              if (s8 === peg$FAILED) {
                s8 = peg$parseFlagParameter();
              }
            }
            if (s8 !== peg$FAILED) {
              peg$savedPos = s6;
              s6 = peg$f43(s2, s3, s8);
            } else {
              peg$currPos = s6;
              s6 = peg$FAILED;
            }
          } else {
            peg$currPos = s6;
            s6 = peg$FAILED;
          }
          while (s6 !== peg$FAILED) {
            s5.push(s6);
            s6 = peg$currPos;
            s7 = [];
            s8 = peg$parseWhiteSpace();
            if (s8 !== peg$FAILED) {
              while (s8 !== peg$FAILED) {
                s7.push(s8);
                s8 = peg$parseWhiteSpace();
              }
            } else {
              s7 = peg$FAILED;
            }
            if (s7 !== peg$FAILED) {
              s8 = peg$parseParameter();
              if (s8 === peg$FAILED) {
                s8 = peg$parseObjectParameter();
                if (s8 === peg$FAILED) {
                  s8 = peg$parseFlagParameter();
                }
              }
              if (s8 !== peg$FAILED) {
                peg$savedPos = s6;
                s6 = peg$f43(s2, s3, s8);
              } else {
                peg$currPos = s6;
                s6 = peg$FAILED;
              }
            } else {
              peg$currPos = s6;
              s6 = peg$FAILED;
            }
          }
          peg$savedPos = s0;
          s0 = peg$f44(s2, s3, s5);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseAutoControlParametersDirective() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8;

    s0 = peg$currPos;
    s1 = peg$currPos;
    peg$silentFails++;
    s2 = peg$parseCondition();
    peg$silentFails--;
    if (s2 === peg$FAILED) {
      s1 = undefined;
    } else {
      peg$currPos = s1;
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      if (input.substr(peg$currPos, 4) === peg$c17) {
        s2 = peg$c17;
        peg$currPos += 4;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e20); }
      }
      if (s2 !== peg$FAILED) {
        s3 = [];
        s4 = peg$parseWhiteSpace();
        if (s4 !== peg$FAILED) {
          while (s4 !== peg$FAILED) {
            s3.push(s4);
            s4 = peg$parseWhiteSpace();
          }
        } else {
          s3 = peg$FAILED;
        }
        if (s3 !== peg$FAILED) {
          s4 = peg$parseParameter();
          if (s4 === peg$FAILED) {
            s4 = peg$parseObjectParameter();
            if (s4 === peg$FAILED) {
              s4 = peg$parseFlagParameter();
            }
          }
          if (s4 !== peg$FAILED) {
            s5 = [];
            s6 = peg$currPos;
            s7 = [];
            s8 = peg$parseWhiteSpace();
            if (s8 !== peg$FAILED) {
              while (s8 !== peg$FAILED) {
                s7.push(s8);
                s8 = peg$parseWhiteSpace();
              }
            } else {
              s7 = peg$FAILED;
            }
            if (s7 !== peg$FAILED) {
              s8 = peg$parseParameter();
              if (s8 === peg$FAILED) {
                s8 = peg$parseObjectParameter();
                if (s8 === peg$FAILED) {
                  s8 = peg$parseFlagParameter();
                }
              }
              if (s8 !== peg$FAILED) {
                peg$savedPos = s6;
                s6 = peg$f45(s4, s8);
              } else {
                peg$currPos = s6;
                s6 = peg$FAILED;
              }
            } else {
              peg$currPos = s6;
              s6 = peg$FAILED;
            }
            while (s6 !== peg$FAILED) {
              s5.push(s6);
              s6 = peg$currPos;
              s7 = [];
              s8 = peg$parseWhiteSpace();
              if (s8 !== peg$FAILED) {
                while (s8 !== peg$FAILED) {
                  s7.push(s8);
                  s8 = peg$parseWhiteSpace();
                }
              } else {
                s7 = peg$FAILED;
              }
              if (s7 !== peg$FAILED) {
                s8 = peg$parseParameter();
                if (s8 === peg$FAILED) {
                  s8 = peg$parseObjectParameter();
                  if (s8 === peg$FAILED) {
                    s8 = peg$parseFlagParameter();
                  }
                }
                if (s8 !== peg$FAILED) {
                  peg$savedPos = s6;
                  s6 = peg$f45(s4, s8);
                } else {
                  peg$currPos = s6;
                  s6 = peg$FAILED;
                }
              } else {
                peg$currPos = s6;
                s6 = peg$FAILED;
              }
            }
            peg$savedPos = s0;
            s0 = peg$f46(s4, s5);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseAnonymousControlParametersDirective() {
    var s0, s1, s2, s3, s4, s5, s6;

    s0 = peg$currPos;
    s1 = peg$currPos;
    peg$silentFails++;
    s2 = peg$parseCondition();
    peg$silentFails--;
    if (s2 === peg$FAILED) {
      s1 = undefined;
    } else {
      peg$currPos = s1;
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parseParameter();
      if (s2 === peg$FAILED) {
        s2 = peg$parseObjectParameter();
      }
      if (s2 !== peg$FAILED) {
        s3 = [];
        s4 = peg$currPos;
        s5 = [];
        s6 = peg$parseWhiteSpace();
        if (s6 !== peg$FAILED) {
          while (s6 !== peg$FAILED) {
            s5.push(s6);
            s6 = peg$parseWhiteSpace();
          }
        } else {
          s5 = peg$FAILED;
        }
        if (s5 !== peg$FAILED) {
          s6 = peg$parseParameter();
          if (s6 === peg$FAILED) {
            s6 = peg$parseObjectParameter();
            if (s6 === peg$FAILED) {
              s6 = peg$parseFlagParameter();
            }
          }
          if (s6 !== peg$FAILED) {
            peg$savedPos = s4;
            s4 = peg$f47(s2, s6);
          } else {
            peg$currPos = s4;
            s4 = peg$FAILED;
          }
        } else {
          peg$currPos = s4;
          s4 = peg$FAILED;
        }
        while (s4 !== peg$FAILED) {
          s3.push(s4);
          s4 = peg$currPos;
          s5 = [];
          s6 = peg$parseWhiteSpace();
          if (s6 !== peg$FAILED) {
            while (s6 !== peg$FAILED) {
              s5.push(s6);
              s6 = peg$parseWhiteSpace();
            }
          } else {
            s5 = peg$FAILED;
          }
          if (s5 !== peg$FAILED) {
            s6 = peg$parseParameter();
            if (s6 === peg$FAILED) {
              s6 = peg$parseObjectParameter();
              if (s6 === peg$FAILED) {
                s6 = peg$parseFlagParameter();
              }
            }
            if (s6 !== peg$FAILED) {
              peg$savedPos = s4;
              s4 = peg$f47(s2, s6);
            } else {
              peg$currPos = s4;
              s4 = peg$FAILED;
            }
          } else {
            peg$currPos = s4;
            s4 = peg$FAILED;
          }
        }
        peg$savedPos = s0;
        s0 = peg$f48(s2, s3);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseTagsDirective() {
    var s0, s1, s2, s3, s4, s5;

    s0 = peg$currPos;
    s1 = peg$parseTag();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = [];
      s5 = peg$parseWhiteSpace();
      if (s5 !== peg$FAILED) {
        while (s5 !== peg$FAILED) {
          s4.push(s5);
          s5 = peg$parseWhiteSpace();
        }
      } else {
        s4 = peg$FAILED;
      }
      if (s4 !== peg$FAILED) {
        s5 = peg$parseTag();
        if (s5 !== peg$FAILED) {
          peg$savedPos = s3;
          s3 = peg$f49(s1, s5);
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = [];
        s5 = peg$parseWhiteSpace();
        if (s5 !== peg$FAILED) {
          while (s5 !== peg$FAILED) {
            s4.push(s5);
            s5 = peg$parseWhiteSpace();
          }
        } else {
          s4 = peg$FAILED;
        }
        if (s4 !== peg$FAILED) {
          s5 = peg$parseTag();
          if (s5 !== peg$FAILED) {
            peg$savedPos = s3;
            s3 = peg$f49(s1, s5);
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f50(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseControlNamespace() {
    var s0, s1, s2;

    s0 = peg$currPos;
    s1 = peg$parseIdentifierAllowingDashesAndHyphens();
    if (s1 !== peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 58) {
        s2 = peg$c18;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e21); }
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f51(s1);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseTypeSettingsSectionParam() {
    var s0, s1, s2;

    s0 = peg$currPos;
    s1 = [];
    s2 = input.charAt(peg$currPos);
    if (peg$r3.test(s2)) {
      peg$currPos++;
    } else {
      s2 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e22); }
    }
    if (s2 !== peg$FAILED) {
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = input.charAt(peg$currPos);
        if (peg$r3.test(s2)) {
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e22); }
        }
      }
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f52(s1);
    }
    s0 = s1;

    return s0;
  }

  function peg$parseParameter() {
    var s0, s1, s2, s3, s4, s5;

    s0 = peg$currPos;
    s1 = peg$parseParamName();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      if (input.charCodeAt(peg$currPos) === 61) {
        s3 = peg$c16;
        peg$currPos++;
      } else {
        s3 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e19); }
      }
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parseFieldReferencingParameterValue();
        if (s5 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f53(s1, s5);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseParamName();
      if (s1 !== peg$FAILED) {
        s2 = peg$parse__();
        if (input.charCodeAt(peg$currPos) === 61) {
          s3 = peg$c16;
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e19); }
        }
        if (s3 !== peg$FAILED) {
          s4 = peg$parse__();
          s5 = peg$parseDoubleQuotedParamValue();
          if (s5 === peg$FAILED) {
            s5 = peg$parseSingleQuotedParamValue();
            if (s5 === peg$FAILED) {
              s5 = peg$parseParamValue();
            }
          }
          if (s5 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f54(s1, s5);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }

    return s0;
  }

  function peg$parseObjectParameter() {
    var s0, s1, s2, s3, s4, s5, s6;

    s0 = peg$currPos;
    s1 = peg$parseParamName();
    if (s1 !== peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 40) {
        s2 = peg$c19;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e23); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse__();
        s4 = peg$parseObjectParameterValues();
        if (s4 === peg$FAILED) {
          s4 = null;
        }
        s5 = peg$parse__();
        if (input.charCodeAt(peg$currPos) === 41) {
          s6 = peg$c20;
          peg$currPos++;
        } else {
          s6 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e24); }
        }
        if (s6 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f55(s1, s4);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseObjectParameterValues() {
    var s0, s1, s2, s3, s4, s5;

    s0 = peg$currPos;
    s1 = peg$parseObjectParameterValue();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = [];
      s5 = peg$parseWhiteSpace();
      if (s5 !== peg$FAILED) {
        while (s5 !== peg$FAILED) {
          s4.push(s5);
          s5 = peg$parseWhiteSpace();
        }
      } else {
        s4 = peg$FAILED;
      }
      if (s4 !== peg$FAILED) {
        s5 = peg$parseObjectParameterValue();
        if (s5 !== peg$FAILED) {
          peg$savedPos = s3;
          s3 = peg$f56(s1, s5);
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = [];
        s5 = peg$parseWhiteSpace();
        if (s5 !== peg$FAILED) {
          while (s5 !== peg$FAILED) {
            s4.push(s5);
            s5 = peg$parseWhiteSpace();
          }
        } else {
          s4 = peg$FAILED;
        }
        if (s4 !== peg$FAILED) {
          s5 = peg$parseObjectParameterValue();
          if (s5 !== peg$FAILED) {
            peg$savedPos = s3;
            s3 = peg$f56(s1, s5);
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f57(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseObjectParameterValue() {
    var s0, s1, s2, s3, s4, s5;

    s0 = peg$currPos;
    s1 = peg$parseParamName();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      if (input.charCodeAt(peg$currPos) === 61) {
        s3 = peg$c16;
        peg$currPos++;
      } else {
        s3 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e19); }
      }
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parseFieldReferencingParameterValue();
        if (s5 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f58(s1, s5);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseParamName();
      if (s1 !== peg$FAILED) {
        s2 = peg$parse__();
        if (input.charCodeAt(peg$currPos) === 61) {
          s3 = peg$c16;
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e19); }
        }
        if (s3 !== peg$FAILED) {
          s4 = peg$parse__();
          s5 = peg$parseDoubleQuotedParamValue();
          if (s5 === peg$FAILED) {
            s5 = peg$parseSingleQuotedParamValue();
            if (s5 === peg$FAILED) {
              s5 = peg$parseObjectParamValue();
            }
          }
          if (s5 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f59(s1, s5);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parseParamName();
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$f60(s1);
        }
        s0 = s1;
      }
    }

    return s0;
  }

  function peg$parseFlagParameter() {
    var s0, s1;

    s0 = peg$currPos;
    s1 = peg$parseParamName();
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f61(s1);
    }
    s0 = s1;

    return s0;
  }

  function peg$parseParamName() {
    var s0, s1, s2, s3, s4;

    s0 = peg$currPos;
    s1 = peg$currPos;
    peg$silentFails++;
    s2 = peg$currPos;
    if (input.substr(peg$currPos, 2) === peg$c9) {
      s3 = peg$c9;
      peg$currPos += 2;
    } else {
      s3 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e11); }
    }
    if (s3 !== peg$FAILED) {
      s4 = peg$parseWhiteSpace();
      if (s4 !== peg$FAILED) {
        s3 = [s3, s4];
        s2 = s3;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
    } else {
      peg$currPos = s2;
      s2 = peg$FAILED;
    }
    peg$silentFails--;
    if (s2 === peg$FAILED) {
      s1 = undefined;
    } else {
      peg$currPos = s1;
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parseIdentifierAllowingDashesAndHyphens();
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f62(s2);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseIdentifierAllowingDashes() {
    var s0, s1, s2, s3;

    s0 = peg$currPos;
    s1 = input.charAt(peg$currPos);
    if (peg$r4.test(s1)) {
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e25); }
    }
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = input.charAt(peg$currPos);
      if (peg$r3.test(s3)) {
        peg$currPos++;
      } else {
        s3 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e22); }
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = input.charAt(peg$currPos);
        if (peg$r3.test(s3)) {
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e22); }
        }
      }
      peg$savedPos = s0;
      s0 = peg$f63(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseIdentifierAllowingDashesAndHyphens() {
    var s0;

    s0 = peg$parseIdentifierAllowingDashes();
    if (s0 === peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 45) {
        s0 = peg$c21;
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e26); }
      }
    }

    return s0;
  }

  function peg$parseQuickTags() {
    var s0, s1, s2, s3, s4, s5, s6, s7;

    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 60) {
      s1 = peg$c22;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e27); }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseTag();
      if (s3 !== peg$FAILED) {
        s4 = [];
        s5 = peg$currPos;
        s6 = [];
        s7 = peg$parseWhiteSpace();
        if (s7 !== peg$FAILED) {
          while (s7 !== peg$FAILED) {
            s6.push(s7);
            s7 = peg$parseWhiteSpace();
          }
        } else {
          s6 = peg$FAILED;
        }
        if (s6 !== peg$FAILED) {
          s7 = peg$parseTag();
          if (s7 !== peg$FAILED) {
            peg$savedPos = s5;
            s5 = peg$f64(s3, s7);
          } else {
            peg$currPos = s5;
            s5 = peg$FAILED;
          }
        } else {
          peg$currPos = s5;
          s5 = peg$FAILED;
        }
        while (s5 !== peg$FAILED) {
          s4.push(s5);
          s5 = peg$currPos;
          s6 = [];
          s7 = peg$parseWhiteSpace();
          if (s7 !== peg$FAILED) {
            while (s7 !== peg$FAILED) {
              s6.push(s7);
              s7 = peg$parseWhiteSpace();
            }
          } else {
            s6 = peg$FAILED;
          }
          if (s6 !== peg$FAILED) {
            s7 = peg$parseTag();
            if (s7 !== peg$FAILED) {
              peg$savedPos = s5;
              s5 = peg$f64(s3, s7);
            } else {
              peg$currPos = s5;
              s5 = peg$FAILED;
            }
          } else {
            peg$currPos = s5;
            s5 = peg$FAILED;
          }
        }
        s5 = peg$parse__();
        if (input.charCodeAt(peg$currPos) === 62) {
          s6 = peg$c23;
          peg$currPos++;
        } else {
          s6 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e28); }
        }
        if (s6 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f65(s3, s4);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseTag() {
    var s0;

    s0 = peg$parseIfTag();
    if (s0 === peg$FAILED) {
      s0 = peg$parseConditionalTag();
      if (s0 === peg$FAILED) {
        s0 = peg$parseTagWithParameters();
        if (s0 === peg$FAILED) {
          s0 = peg$parseTagWithValue();
          if (s0 === peg$FAILED) {
            s0 = peg$parseTagFlag();
          }
        }
      }
    }

    return s0;
  }

  function peg$parseIfTag() {
    var s0, s1, s2, s3;

    s0 = peg$currPos;
    if (input.substr(peg$currPos, 2) === peg$c9) {
      s1 = peg$c9;
      peg$currPos += 2;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e11); }
    }
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$parseWhiteSpace();
      if (s3 !== peg$FAILED) {
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$parseWhiteSpace();
        }
      } else {
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parseIfStatement();
        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f66(s3);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseConditionalTag() {
    var s0, s1, s2, s3;

    s0 = peg$currPos;
    s1 = peg$parseTagWithParameters();
    if (s1 === peg$FAILED) {
      s1 = peg$parseTagWithValue();
      if (s1 === peg$FAILED) {
        s1 = peg$parseTagFlag();
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$parseWhiteSpace();
      if (s3 !== peg$FAILED) {
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$parseWhiteSpace();
        }
      } else {
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parseTagCondition();
        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f67(s1, s3);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseTagCondition() {
    var s0, s1, s2, s3;

    s0 = peg$currPos;
    if (input.substr(peg$currPos, 2) === peg$c9) {
      s1 = peg$c9;
      peg$currPos += 2;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e11); }
    }
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$parseWhiteSpace();
      if (s3 !== peg$FAILED) {
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$parseWhiteSpace();
        }
      } else {
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parseIfStatement();
        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f68(s3);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseIfStatement() {
    var s0;

    s0 = peg$parseDoubleQuotedParamValue();
    if (s0 === peg$FAILED) {
      s0 = peg$parseSingleQuotedParamValue();
      if (s0 === peg$FAILED) {
        s0 = peg$parseRawIfStatement();
      }
    }

    return s0;
  }

  function peg$parseRawIfStatement() {
    var s0, s1, s2, s3, s4;

    s0 = peg$currPos;
    s1 = [];
    s2 = peg$currPos;
    if (input.substr(peg$currPos, 2) === peg$c24) {
      s3 = peg$c24;
      peg$currPos += 2;
    } else {
      s3 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e29); }
    }
    if (s3 !== peg$FAILED) {
      peg$savedPos = s2;
      s3 = peg$f69();
    }
    s2 = s3;
    if (s2 === peg$FAILED) {
      s2 = peg$currPos;
      if (input.substr(peg$currPos, 2) === peg$c25) {
        s3 = peg$c25;
        peg$currPos += 2;
      } else {
        s3 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e30); }
      }
      if (s3 !== peg$FAILED) {
        peg$savedPos = s2;
        s3 = peg$f70();
      }
      s2 = s3;
      if (s2 === peg$FAILED) {
        s2 = peg$currPos;
        s3 = peg$currPos;
        peg$silentFails++;
        if (input.charCodeAt(peg$currPos) === 62) {
          s4 = peg$c23;
          peg$currPos++;
        } else {
          s4 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e28); }
        }
        peg$silentFails--;
        if (s4 === peg$FAILED) {
          s3 = undefined;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
        if (s3 !== peg$FAILED) {
          s4 = peg$parseLineCharacter();
          if (s4 !== peg$FAILED) {
            peg$savedPos = s2;
            s2 = peg$f71(s4);
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      }
    }
    if (s2 !== peg$FAILED) {
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c24) {
          s3 = peg$c24;
          peg$currPos += 2;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e29); }
        }
        if (s3 !== peg$FAILED) {
          peg$savedPos = s2;
          s3 = peg$f69();
        }
        s2 = s3;
        if (s2 === peg$FAILED) {
          s2 = peg$currPos;
          if (input.substr(peg$currPos, 2) === peg$c25) {
            s3 = peg$c25;
            peg$currPos += 2;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$e30); }
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s2;
            s3 = peg$f70();
          }
          s2 = s3;
          if (s2 === peg$FAILED) {
            s2 = peg$currPos;
            s3 = peg$currPos;
            peg$silentFails++;
            if (input.charCodeAt(peg$currPos) === 62) {
              s4 = peg$c23;
              peg$currPos++;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$e28); }
            }
            peg$silentFails--;
            if (s4 === peg$FAILED) {
              s3 = undefined;
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
            if (s3 !== peg$FAILED) {
              s4 = peg$parseLineCharacter();
              if (s4 !== peg$FAILED) {
                peg$savedPos = s2;
                s2 = peg$f71(s4);
              } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$FAILED;
            }
          }
        }
      }
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f72(s1);
    }
    s0 = s1;

    return s0;
  }

  function peg$parseTagWithParameters() {
    var s0, s1, s2, s3, s4, s5, s6;

    s0 = peg$currPos;
    s1 = peg$parseTagName();
    if (s1 !== peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 40) {
        s2 = peg$c19;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e23); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse__();
        s4 = peg$parseTagParameters();
        if (s4 === peg$FAILED) {
          s4 = null;
        }
        s5 = peg$parse__();
        if (input.charCodeAt(peg$currPos) === 41) {
          s6 = peg$c20;
          peg$currPos++;
        } else {
          s6 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e24); }
        }
        if (s6 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f73(s1, s4);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseTagParameters() {
    var s0, s1, s2, s3, s4, s5;

    s0 = peg$currPos;
    s1 = peg$parseTagParameter();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = [];
      s5 = peg$parseWhiteSpace();
      if (s5 !== peg$FAILED) {
        while (s5 !== peg$FAILED) {
          s4.push(s5);
          s5 = peg$parseWhiteSpace();
        }
      } else {
        s4 = peg$FAILED;
      }
      if (s4 !== peg$FAILED) {
        s5 = peg$parseTagParameter();
        if (s5 !== peg$FAILED) {
          peg$savedPos = s3;
          s3 = peg$f74(s1, s5);
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = [];
        s5 = peg$parseWhiteSpace();
        if (s5 !== peg$FAILED) {
          while (s5 !== peg$FAILED) {
            s4.push(s5);
            s5 = peg$parseWhiteSpace();
          }
        } else {
          s4 = peg$FAILED;
        }
        if (s4 !== peg$FAILED) {
          s5 = peg$parseTagParameter();
          if (s5 !== peg$FAILED) {
            peg$savedPos = s3;
            s3 = peg$f74(s1, s5);
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f75(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseTagParameter() {
    var s0, s1, s2, s3, s4, s5;

    s0 = peg$currPos;
    s1 = peg$parseParamName();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      if (input.charCodeAt(peg$currPos) === 61) {
        s3 = peg$c16;
        peg$currPos++;
      } else {
        s3 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e19); }
      }
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parseFieldReferencingParameterValue();
        if (s5 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f76(s1, s5);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseParamName();
      if (s1 !== peg$FAILED) {
        s2 = peg$parse__();
        if (input.charCodeAt(peg$currPos) === 61) {
          s3 = peg$c16;
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e19); }
        }
        if (s3 !== peg$FAILED) {
          s4 = peg$parse__();
          s5 = peg$parseDoubleQuotedParamValue();
          if (s5 === peg$FAILED) {
            s5 = peg$parseSingleQuotedParamValue();
            if (s5 === peg$FAILED) {
              s5 = peg$parseTagParamValue();
            }
          }
          if (s5 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f77(s1, s5);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parseParamName();
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$f78(s1);
        }
        s0 = s1;
      }
    }

    return s0;
  }

  function peg$parseTagWithValue() {
    var s0, s1, s2, s3;

    s0 = peg$currPos;
    s1 = peg$parseTagName();
    if (s1 !== peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 61) {
        s2 = peg$c16;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e19); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parseDoubleQuotedParamValue();
        if (s3 === peg$FAILED) {
          s3 = peg$parseSingleQuotedParamValue();
          if (s3 === peg$FAILED) {
            s3 = peg$parseParamValue();
          }
        }
        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f79(s1, s3);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseTagFlag() {
    var s0, s1;

    s0 = peg$currPos;
    s1 = peg$parseTagName();
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f80(s1);
    }
    s0 = s1;

    return s0;
  }

  function peg$parseTagName() {
    var s0, s1, s2, s3, s4;

    s0 = peg$currPos;
    s1 = peg$currPos;
    peg$silentFails++;
    s2 = peg$currPos;
    if (input.substr(peg$currPos, 2) === peg$c9) {
      s3 = peg$c9;
      peg$currPos += 2;
    } else {
      s3 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e11); }
    }
    if (s3 !== peg$FAILED) {
      s4 = peg$parseWhiteSpace();
      if (s4 !== peg$FAILED) {
        s3 = [s3, s4];
        s2 = s3;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
    } else {
      peg$currPos = s2;
      s2 = peg$FAILED;
    }
    peg$silentFails--;
    if (s2 === peg$FAILED) {
      s1 = undefined;
    } else {
      peg$currPos = s1;
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parseIdentifierAllowingDashesAndColons();
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f81(s2);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseIdentifierAllowingDashesAndColons() {
    var s0, s1, s2, s3;

    s0 = peg$currPos;
    s1 = input.charAt(peg$currPos);
    if (peg$r4.test(s1)) {
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e25); }
    }
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = input.charAt(peg$currPos);
      if (peg$r5.test(s3)) {
        peg$currPos++;
      } else {
        s3 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e31); }
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = input.charAt(peg$currPos);
        if (peg$r5.test(s3)) {
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e31); }
        }
      }
      peg$savedPos = s0;
      s0 = peg$f82(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseUnitOfWidth() {
    var s0;

    if (input.substr(peg$currPos, 2) === peg$c26) {
      s0 = peg$c26;
      peg$currPos += 2;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e32); }
    }
    if (s0 === peg$FAILED) {
      if (input.substr(peg$currPos, 2) === peg$c27) {
        s0 = peg$c27;
        peg$currPos += 2;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e33); }
      }
      if (s0 === peg$FAILED) {
        if (input.substr(peg$currPos, 3) === peg$c28) {
          s0 = peg$c28;
          peg$currPos += 3;
        } else {
          s0 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e34); }
        }
        if (s0 === peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 42) {
            s0 = peg$c29;
            peg$currPos++;
          } else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$e35); }
          }
          if (s0 === peg$FAILED) {
            if (input.substr(peg$currPos, 3) === peg$c30) {
              s0 = peg$c30;
              peg$currPos += 3;
            } else {
              s0 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$e36); }
            }
            if (s0 === peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 37) {
                s0 = peg$c31;
                peg$currPos++;
              } else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$e37); }
              }
            }
          }
        }
      }
    }

    return s0;
  }

  function peg$parseFieldDirectiveSeparator() {
    var s0, s1, s2, s3;

    s0 = peg$currPos;
    s1 = [];
    s2 = peg$parseWhiteSpace();
    if (s2 === peg$FAILED) {
      s2 = peg$parseLineTerminator();
    }
    while (s2 !== peg$FAILED) {
      s1.push(s2);
      s2 = peg$parseWhiteSpace();
      if (s2 === peg$FAILED) {
        s2 = peg$parseLineTerminator();
      }
    }
    s2 = peg$currPos;
    peg$silentFails++;
    if (input.charCodeAt(peg$currPos) === 123) {
      s3 = peg$c3;
      peg$currPos++;
    } else {
      s3 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e3); }
    }
    peg$silentFails--;
    if (s3 !== peg$FAILED) {
      peg$currPos = s2;
      s2 = undefined;
    } else {
      s2 = peg$FAILED;
    }
    if (s2 !== peg$FAILED) {
      s1 = [s1, s2];
      s0 = s1;
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseSectionDirectiveSeparator() {
    var s0, s1, s2, s3, s4, s5;

    s0 = peg$currPos;
    s1 = [];
    s2 = peg$parseWhiteSpace();
    while (s2 !== peg$FAILED) {
      s1.push(s2);
      s2 = peg$parseWhiteSpace();
    }
    s2 = peg$parseLineTerminatorSequence();
    if (s2 !== peg$FAILED) {
      s3 = [];
      s4 = peg$parseWhiteSpace();
      while (s4 !== peg$FAILED) {
        s3.push(s4);
        s4 = peg$parseWhiteSpace();
      }
      s4 = peg$currPos;
      peg$silentFails++;
      if (input.charCodeAt(peg$currPos) === 123) {
        s5 = peg$c3;
        peg$currPos++;
      } else {
        s5 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e3); }
      }
      peg$silentFails--;
      if (s5 !== peg$FAILED) {
        peg$currPos = s4;
        s4 = undefined;
      } else {
        s4 = peg$FAILED;
      }
      if (s4 !== peg$FAILED) {
        s1 = [s1, s2, s3, s4];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseParamValue() {
    var s0, s1, s2;

    s0 = peg$currPos;
    s1 = [];
    s2 = input.charAt(peg$currPos);
    if (peg$r6.test(s2)) {
      peg$currPos++;
    } else {
      s2 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e38); }
    }
    if (s2 !== peg$FAILED) {
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = input.charAt(peg$currPos);
        if (peg$r6.test(s2)) {
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e38); }
        }
      }
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f83(s1);
    }
    s0 = s1;

    return s0;
  }

  function peg$parseTagParamValue() {
    var s0, s1, s2;

    s0 = peg$currPos;
    s1 = [];
    s2 = input.charAt(peg$currPos);
    if (peg$r7.test(s2)) {
      peg$currPos++;
    } else {
      s2 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e39); }
    }
    if (s2 !== peg$FAILED) {
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = input.charAt(peg$currPos);
        if (peg$r7.test(s2)) {
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e39); }
        }
      }
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f84(s1);
    }
    s0 = s1;

    return s0;
  }

  function peg$parseObjectParamValue() {
    var s0, s1, s2;

    s0 = peg$currPos;
    s1 = [];
    s2 = input.charAt(peg$currPos);
    if (peg$r7.test(s2)) {
      peg$currPos++;
    } else {
      s2 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e39); }
    }
    if (s2 !== peg$FAILED) {
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = input.charAt(peg$currPos);
        if (peg$r7.test(s2)) {
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e39); }
        }
      }
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f85(s1);
    }
    s0 = s1;

    return s0;
  }

  function peg$parseDoubleQuotedParamValue() {
    var s0, s1, s2, s3;

    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 34) {
      s1 = peg$c32;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e40); }
    }
    if (s1 !== peg$FAILED) {
      s2 = [];
      if (input.substr(peg$currPos, 2) === peg$c33) {
        s3 = peg$c33;
        peg$currPos += 2;
      } else {
        s3 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e41); }
      }
      if (s3 === peg$FAILED) {
        s3 = input.charAt(peg$currPos);
        if (peg$r8.test(s3)) {
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e42); }
        }
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        if (input.substr(peg$currPos, 2) === peg$c33) {
          s3 = peg$c33;
          peg$currPos += 2;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e41); }
        }
        if (s3 === peg$FAILED) {
          s3 = input.charAt(peg$currPos);
          if (peg$r8.test(s3)) {
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$e42); }
          }
        }
      }
      if (input.charCodeAt(peg$currPos) === 34) {
        s3 = peg$c32;
        peg$currPos++;
      } else {
        s3 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e40); }
      }
      if (s3 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f86(s2);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseSingleQuotedParamValue() {
    var s0, s1, s2, s3;

    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 39) {
      s1 = peg$c34;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e43); }
    }
    if (s1 !== peg$FAILED) {
      s2 = [];
      if (input.substr(peg$currPos, 2) === peg$c35) {
        s3 = peg$c35;
        peg$currPos += 2;
      } else {
        s3 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e44); }
      }
      if (s3 === peg$FAILED) {
        s3 = input.charAt(peg$currPos);
        if (peg$r9.test(s3)) {
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e45); }
        }
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        if (input.substr(peg$currPos, 2) === peg$c35) {
          s3 = peg$c35;
          peg$currPos += 2;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e44); }
        }
        if (s3 === peg$FAILED) {
          s3 = input.charAt(peg$currPos);
          if (peg$r9.test(s3)) {
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$e45); }
          }
        }
      }
      if (input.charCodeAt(peg$currPos) === 39) {
        s3 = peg$c34;
        peg$currPos++;
      } else {
        s3 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e43); }
      }
      if (s3 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f87(s2);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseFieldReferencingParameterValue() {
    var s0, s1, s2, s3, s4, s5, s6;

    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 91) {
      s1 = peg$c5;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e5); }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parseFieldName();
      if (s2 !== peg$FAILED) {
        s3 = [];
        s4 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 46) {
          s5 = peg$c36;
          peg$currPos++;
        } else {
          s5 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e46); }
        }
        if (s5 !== peg$FAILED) {
          s6 = peg$parseFieldName();
          if (s6 !== peg$FAILED) {
            peg$savedPos = s4;
            s4 = peg$f88(s2, s6);
          } else {
            peg$currPos = s4;
            s4 = peg$FAILED;
          }
        } else {
          peg$currPos = s4;
          s4 = peg$FAILED;
        }
        while (s4 !== peg$FAILED) {
          s3.push(s4);
          s4 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 46) {
            s5 = peg$c36;
            peg$currPos++;
          } else {
            s5 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$e46); }
          }
          if (s5 !== peg$FAILED) {
            s6 = peg$parseFieldName();
            if (s6 !== peg$FAILED) {
              peg$savedPos = s4;
              s4 = peg$f88(s2, s6);
            } else {
              peg$currPos = s4;
              s4 = peg$FAILED;
            }
          } else {
            peg$currPos = s4;
            s4 = peg$FAILED;
          }
        }
        if (input.charCodeAt(peg$currPos) === 93) {
          s4 = peg$c7;
          peg$currPos++;
        } else {
          s4 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e7); }
        }
        if (s4 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f89(s2, s3);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parse_StyledTypeDefinition() {
    var s0, s1, s2, s3;

    s0 = peg$parseTypeDefinition();
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseFieldDirectives();
      if (s1 !== peg$FAILED) {
        s2 = peg$parseTypeDefinition();
        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f90(s1, s2);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parseFieldDirectives();
        if (s1 !== peg$FAILED) {
          s2 = peg$parseEOL();
          if (s2 !== peg$FAILED) {
            s3 = peg$parseTypeDefinition();
            if (s3 !== peg$FAILED) {
              peg$savedPos = s0;
              s0 = peg$f91(s1, s3);
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      }
    }

    return s0;
  }

  function peg$parseTypeDefinition() {
    var s0, s1, s2, s3, s4, s5, s6, s7;

    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 91) {
      s1 = peg$c5;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e5); }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parseFieldName();
      if (s2 !== peg$FAILED) {
        if (input.charCodeAt(peg$currPos) === 93) {
          s3 = peg$c7;
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e7); }
        }
        if (s3 !== peg$FAILED) {
          s4 = peg$parse__();
          if (input.charCodeAt(peg$currPos) === 58) {
            s5 = peg$c18;
            peg$currPos++;
          } else {
            s5 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$e21); }
          }
          if (s5 !== peg$FAILED) {
            s6 = peg$parse__();
            s7 = peg$parseTypeSpec();
            if (s7 !== peg$FAILED) {
              peg$savedPos = s0;
              s0 = peg$f92(s2, s7);
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseTypeSpec() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11;

    s0 = peg$currPos;
    s1 = peg$parseTypeReference();
    if (s1 === peg$FAILED) {
      s1 = null;
    }
    s2 = peg$parse__();
    s3 = peg$parseCardinality();
    if (s3 === peg$FAILED) {
      s3 = null;
    }
    s4 = [];
    s5 = peg$currPos;
    s6 = peg$parse__();
    s7 = peg$parseQuickTags();
    if (s7 !== peg$FAILED) {
      peg$savedPos = s5;
      s5 = peg$f93(s1, s3, s7);
    } else {
      peg$currPos = s5;
      s5 = peg$FAILED;
    }
    while (s5 !== peg$FAILED) {
      s4.push(s5);
      s5 = peg$currPos;
      s6 = peg$parse__();
      s7 = peg$parseQuickTags();
      if (s7 !== peg$FAILED) {
        peg$savedPos = s5;
        s5 = peg$f93(s1, s3, s7);
      } else {
        peg$currPos = s5;
        s5 = peg$FAILED;
      }
    }
    s5 = peg$parse__();
    s6 = peg$parseFormula();
    if (s6 === peg$FAILED) {
      s6 = null;
    }
    s7 = peg$parse__();
    s8 = peg$parseQuickHelp();
    if (s8 === peg$FAILED) {
      s8 = null;
    }
    s9 = peg$parseEOL();
    if (s9 !== peg$FAILED) {
      s10 = peg$parseContinuationTypeSpecBlock();
      if (s10 === peg$FAILED) {
        s10 = null;
      }
      s11 = peg$parseTypeSettings();
      if (s11 === peg$FAILED) {
        s11 = null;
      }
      peg$savedPos = s0;
      s0 = peg$f94(s1, s3, s4, s6, s8, s10, s11);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseEOL();
      if (s1 !== peg$FAILED) {
        s2 = peg$parseTypeSettings();
        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f95(s2);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }

    return s0;
  }

  function peg$parseContinuationTypeSpecBlock() {
    var s0, s1, s2, s3;

    s0 = peg$currPos;
    s1 = [];
    s2 = peg$parseContinuationTypeSpecLine();
    if (s2 !== peg$FAILED) {
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parseContinuationTypeSpecLine();
      }
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$parseEmptyLine();
      if (s3 !== peg$FAILED) {
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$parseEmptyLine();
        }
      } else {
        s2 = peg$FAILED;
      }
      if (s2 === peg$FAILED) {
        s2 = peg$parseEOF();
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f96(s1);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseContinuationTypeSpecLine() {
    var s0, s1, s2, s3, s4, s5, s6, s7;

    s0 = peg$currPos;
    s1 = peg$parseIndent();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseQuickTags();
      if (s3 !== peg$FAILED) {
        s4 = [];
        s5 = peg$currPos;
        s6 = peg$parse__();
        s7 = peg$parseQuickTags();
        if (s7 !== peg$FAILED) {
          peg$savedPos = s5;
          s5 = peg$f97(s3, s7);
        } else {
          peg$currPos = s5;
          s5 = peg$FAILED;
        }
        while (s5 !== peg$FAILED) {
          s4.push(s5);
          s5 = peg$currPos;
          s6 = peg$parse__();
          s7 = peg$parseQuickTags();
          if (s7 !== peg$FAILED) {
            peg$savedPos = s5;
            s5 = peg$f97(s3, s7);
          } else {
            peg$currPos = s5;
            s5 = peg$FAILED;
          }
        }
        s5 = peg$parse__();
        s6 = peg$parseEOL();
        if (s6 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f98(s3, s4);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseIndent();
      if (s1 !== peg$FAILED) {
        s2 = peg$parse__();
        s3 = peg$parseFormula();
        if (s3 !== peg$FAILED) {
          s4 = peg$parse__();
          s5 = peg$parseEOL();
          if (s5 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f99(s3);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }

    return s0;
  }

  function peg$parseTypeReference() {
    var s0, s1, s2, s3;

    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 4);
    if (s1.toLowerCase() === peg$c37) {
      peg$currPos += 4;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e47); }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      if (input.charCodeAt(peg$currPos) === 40) {
        s3 = peg$c19;
        peg$currPos++;
      } else {
        s3 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e23); }
      }
      if (s3 === peg$FAILED) {
        s3 = peg$parseWhiteSpace();
        if (s3 === peg$FAILED) {
          s3 = peg$parseEOL();
        }
      }
      peg$silentFails--;
      if (s3 !== peg$FAILED) {
        peg$currPos = s2;
        s2 = undefined;
      } else {
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f100();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = input.substr(peg$currPos, 8);
      if (s1.toLowerCase() === peg$c38) {
        peg$currPos += 8;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e48); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$currPos;
        peg$silentFails++;
        if (input.charCodeAt(peg$currPos) === 40) {
          s3 = peg$c19;
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e23); }
        }
        if (s3 === peg$FAILED) {
          s3 = peg$parseWhiteSpace();
          if (s3 === peg$FAILED) {
            s3 = peg$parseEOL();
          }
        }
        peg$silentFails--;
        if (s3 !== peg$FAILED) {
          peg$currPos = s2;
          s2 = undefined;
        } else {
          s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f101();
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = input.substr(peg$currPos, 6);
        if (s1.toLowerCase() === peg$c39) {
          peg$currPos += 6;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e49); }
        }
        if (s1 !== peg$FAILED) {
          s2 = peg$currPos;
          peg$silentFails++;
          if (input.charCodeAt(peg$currPos) === 40) {
            s3 = peg$c19;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$e23); }
          }
          if (s3 === peg$FAILED) {
            s3 = peg$parseWhiteSpace();
            if (s3 === peg$FAILED) {
              s3 = peg$parseEOL();
            }
          }
          peg$silentFails--;
          if (s3 !== peg$FAILED) {
            peg$currPos = s2;
            s2 = undefined;
          } else {
            s2 = peg$FAILED;
          }
          if (s2 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f102();
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          s1 = input.substr(peg$currPos, 6);
          if (s1.toLowerCase() === peg$c40) {
            peg$currPos += 6;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$e50); }
          }
          if (s1 !== peg$FAILED) {
            s2 = peg$currPos;
            peg$silentFails++;
            if (input.charCodeAt(peg$currPos) === 40) {
              s3 = peg$c19;
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$e23); }
            }
            if (s3 === peg$FAILED) {
              s3 = peg$parseWhiteSpace();
              if (s3 === peg$FAILED) {
                s3 = peg$parseEOL();
              }
            }
            peg$silentFails--;
            if (s3 !== peg$FAILED) {
              peg$currPos = s2;
              s2 = undefined;
            } else {
              s2 = peg$FAILED;
            }
            if (s2 !== peg$FAILED) {
              peg$savedPos = s0;
              s0 = peg$f103();
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = input.substr(peg$currPos, 6);
            if (s1.toLowerCase() === peg$c41) {
              peg$currPos += 6;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$e51); }
            }
            if (s1 !== peg$FAILED) {
              s2 = peg$currPos;
              peg$silentFails++;
              if (input.charCodeAt(peg$currPos) === 40) {
                s3 = peg$c19;
                peg$currPos++;
              } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$e23); }
              }
              if (s3 === peg$FAILED) {
                s3 = peg$parseWhiteSpace();
                if (s3 === peg$FAILED) {
                  s3 = peg$parseEOL();
                }
              }
              peg$silentFails--;
              if (s3 !== peg$FAILED) {
                peg$currPos = s2;
                s2 = undefined;
              } else {
                s2 = peg$FAILED;
              }
              if (s2 !== peg$FAILED) {
                peg$savedPos = s0;
                s0 = peg$f104();
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              s1 = input.substr(peg$currPos, 4);
              if (s1.toLowerCase() === peg$c42) {
                peg$currPos += 4;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$e52); }
              }
              if (s1 !== peg$FAILED) {
                s2 = peg$currPos;
                peg$silentFails++;
                if (input.charCodeAt(peg$currPos) === 40) {
                  s3 = peg$c19;
                  peg$currPos++;
                } else {
                  s3 = peg$FAILED;
                  if (peg$silentFails === 0) { peg$fail(peg$e23); }
                }
                if (s3 === peg$FAILED) {
                  s3 = peg$parseWhiteSpace();
                  if (s3 === peg$FAILED) {
                    s3 = peg$parseEOL();
                  }
                }
                peg$silentFails--;
                if (s3 !== peg$FAILED) {
                  peg$currPos = s2;
                  s2 = undefined;
                } else {
                  s2 = peg$FAILED;
                }
                if (s2 !== peg$FAILED) {
                  peg$savedPos = s0;
                  s0 = peg$f105();
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = input.substr(peg$currPos, 8);
                if (s1.toLowerCase() === peg$c43) {
                  peg$currPos += 8;
                } else {
                  s1 = peg$FAILED;
                  if (peg$silentFails === 0) { peg$fail(peg$e53); }
                }
                if (s1 !== peg$FAILED) {
                  s2 = peg$currPos;
                  peg$silentFails++;
                  if (input.charCodeAt(peg$currPos) === 40) {
                    s3 = peg$c19;
                    peg$currPos++;
                  } else {
                    s3 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$e23); }
                  }
                  if (s3 === peg$FAILED) {
                    s3 = peg$parseWhiteSpace();
                    if (s3 === peg$FAILED) {
                      s3 = peg$parseEOL();
                    }
                  }
                  peg$silentFails--;
                  if (s3 !== peg$FAILED) {
                    peg$currPos = s2;
                    s2 = undefined;
                  } else {
                    s2 = peg$FAILED;
                  }
                  if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s0 = peg$f106();
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
                if (s0 === peg$FAILED) {
                  s0 = peg$currPos;
                  s1 = input.substr(peg$currPos, 4);
                  if (s1.toLowerCase() === peg$c44) {
                    peg$currPos += 4;
                  } else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$e54); }
                  }
                  if (s1 !== peg$FAILED) {
                    s2 = peg$currPos;
                    peg$silentFails++;
                    if (input.charCodeAt(peg$currPos) === 40) {
                      s3 = peg$c19;
                      peg$currPos++;
                    } else {
                      s3 = peg$FAILED;
                      if (peg$silentFails === 0) { peg$fail(peg$e23); }
                    }
                    if (s3 === peg$FAILED) {
                      s3 = peg$parseWhiteSpace();
                      if (s3 === peg$FAILED) {
                        s3 = peg$parseEOL();
                      }
                    }
                    peg$silentFails--;
                    if (s3 !== peg$FAILED) {
                      peg$currPos = s2;
                      s2 = undefined;
                    } else {
                      s2 = peg$FAILED;
                    }
                    if (s2 !== peg$FAILED) {
                      peg$savedPos = s0;
                      s0 = peg$f107();
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                  if (s0 === peg$FAILED) {
                    s0 = peg$currPos;
                    s1 = input.substr(peg$currPos, 9);
                    if (s1.toLowerCase() === peg$c45) {
                      peg$currPos += 9;
                    } else {
                      s1 = peg$FAILED;
                      if (peg$silentFails === 0) { peg$fail(peg$e55); }
                    }
                    if (s1 !== peg$FAILED) {
                      s2 = peg$currPos;
                      peg$silentFails++;
                      if (input.charCodeAt(peg$currPos) === 40) {
                        s3 = peg$c19;
                        peg$currPos++;
                      } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) { peg$fail(peg$e23); }
                      }
                      if (s3 === peg$FAILED) {
                        s3 = peg$parseWhiteSpace();
                        if (s3 === peg$FAILED) {
                          s3 = peg$parseEOL();
                        }
                      }
                      peg$silentFails--;
                      if (s3 !== peg$FAILED) {
                        peg$currPos = s2;
                        s2 = undefined;
                      } else {
                        s2 = peg$FAILED;
                      }
                      if (s2 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s0 = peg$f108();
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                    if (s0 === peg$FAILED) {
                      s0 = peg$currPos;
                      s1 = input.substr(peg$currPos, 11);
                      if (s1.toLowerCase() === peg$c46) {
                        peg$currPos += 11;
                      } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) { peg$fail(peg$e56); }
                      }
                      if (s1 !== peg$FAILED) {
                        s2 = peg$currPos;
                        peg$silentFails++;
                        if (input.charCodeAt(peg$currPos) === 40) {
                          s3 = peg$c19;
                          peg$currPos++;
                        } else {
                          s3 = peg$FAILED;
                          if (peg$silentFails === 0) { peg$fail(peg$e23); }
                        }
                        if (s3 === peg$FAILED) {
                          s3 = peg$parseWhiteSpace();
                          if (s3 === peg$FAILED) {
                            s3 = peg$parseEOL();
                          }
                        }
                        peg$silentFails--;
                        if (s3 !== peg$FAILED) {
                          peg$currPos = s2;
                          s2 = undefined;
                        } else {
                          s2 = peg$FAILED;
                        }
                        if (s2 !== peg$FAILED) {
                          peg$savedPos = s0;
                          s0 = peg$f109();
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                      if (s0 === peg$FAILED) {
                        s0 = peg$currPos;
                        s1 = input.substr(peg$currPos, 5);
                        if (s1.toLowerCase() === peg$c47) {
                          peg$currPos += 5;
                        } else {
                          s1 = peg$FAILED;
                          if (peg$silentFails === 0) { peg$fail(peg$e57); }
                        }
                        if (s1 !== peg$FAILED) {
                          s2 = peg$currPos;
                          peg$silentFails++;
                          if (input.charCodeAt(peg$currPos) === 40) {
                            s3 = peg$c19;
                            peg$currPos++;
                          } else {
                            s3 = peg$FAILED;
                            if (peg$silentFails === 0) { peg$fail(peg$e23); }
                          }
                          if (s3 === peg$FAILED) {
                            s3 = peg$parseWhiteSpace();
                            if (s3 === peg$FAILED) {
                              s3 = peg$parseEOL();
                            }
                          }
                          peg$silentFails--;
                          if (s3 !== peg$FAILED) {
                            peg$currPos = s2;
                            s2 = undefined;
                          } else {
                            s2 = peg$FAILED;
                          }
                          if (s2 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s0 = peg$f110();
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                        if (s0 === peg$FAILED) {
                          s0 = peg$currPos;
                          s1 = input.substr(peg$currPos, 4);
                          if (s1.toLowerCase() === peg$c48) {
                            peg$currPos += 4;
                          } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) { peg$fail(peg$e58); }
                          }
                          if (s1 !== peg$FAILED) {
                            s2 = peg$currPos;
                            peg$silentFails++;
                            if (input.charCodeAt(peg$currPos) === 40) {
                              s3 = peg$c19;
                              peg$currPos++;
                            } else {
                              s3 = peg$FAILED;
                              if (peg$silentFails === 0) { peg$fail(peg$e23); }
                            }
                            if (s3 === peg$FAILED) {
                              s3 = peg$parseWhiteSpace();
                              if (s3 === peg$FAILED) {
                                s3 = peg$parseEOL();
                              }
                            }
                            peg$silentFails--;
                            if (s3 !== peg$FAILED) {
                              peg$currPos = s2;
                              s2 = undefined;
                            } else {
                              s2 = peg$FAILED;
                            }
                            if (s2 !== peg$FAILED) {
                              peg$savedPos = s0;
                              s0 = peg$f111();
                            } else {
                              peg$currPos = s0;
                              s0 = peg$FAILED;
                            }
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                          if (s0 === peg$FAILED) {
                            s0 = peg$currPos;
                            s1 = input.substr(peg$currPos, 4);
                            if (s1.toLowerCase() === peg$c49) {
                              peg$currPos += 4;
                            } else {
                              s1 = peg$FAILED;
                              if (peg$silentFails === 0) { peg$fail(peg$e59); }
                            }
                            if (s1 !== peg$FAILED) {
                              s2 = peg$currPos;
                              peg$silentFails++;
                              if (input.charCodeAt(peg$currPos) === 40) {
                                s3 = peg$c19;
                                peg$currPos++;
                              } else {
                                s3 = peg$FAILED;
                                if (peg$silentFails === 0) { peg$fail(peg$e23); }
                              }
                              if (s3 === peg$FAILED) {
                                s3 = peg$parseWhiteSpace();
                                if (s3 === peg$FAILED) {
                                  s3 = peg$parseEOL();
                                }
                              }
                              peg$silentFails--;
                              if (s3 !== peg$FAILED) {
                                peg$currPos = s2;
                                s2 = undefined;
                              } else {
                                s2 = peg$FAILED;
                              }
                              if (s2 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s0 = peg$f112();
                              } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                              }
                            } else {
                              peg$currPos = s0;
                              s0 = peg$FAILED;
                            }
                            if (s0 === peg$FAILED) {
                              s0 = peg$currPos;
                              s1 = input.substr(peg$currPos, 8);
                              if (s1.toLowerCase() === peg$c50) {
                                peg$currPos += 8;
                              } else {
                                s1 = peg$FAILED;
                                if (peg$silentFails === 0) { peg$fail(peg$e60); }
                              }
                              if (s1 !== peg$FAILED) {
                                s2 = peg$currPos;
                                peg$silentFails++;
                                if (input.charCodeAt(peg$currPos) === 40) {
                                  s3 = peg$c19;
                                  peg$currPos++;
                                } else {
                                  s3 = peg$FAILED;
                                  if (peg$silentFails === 0) { peg$fail(peg$e23); }
                                }
                                if (s3 === peg$FAILED) {
                                  s3 = peg$parseWhiteSpace();
                                  if (s3 === peg$FAILED) {
                                    s3 = peg$parseEOL();
                                  }
                                }
                                peg$silentFails--;
                                if (s3 !== peg$FAILED) {
                                  peg$currPos = s2;
                                  s2 = undefined;
                                } else {
                                  s2 = peg$FAILED;
                                }
                                if (s2 !== peg$FAILED) {
                                  peg$savedPos = s0;
                                  s0 = peg$f113();
                                } else {
                                  peg$currPos = s0;
                                  s0 = peg$FAILED;
                                }
                              } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                              }
                              if (s0 === peg$FAILED) {
                                s0 = peg$currPos;
                                s1 = input.substr(peg$currPos, 3);
                                if (s1.toLowerCase() === peg$c51) {
                                  peg$currPos += 3;
                                } else {
                                  s1 = peg$FAILED;
                                  if (peg$silentFails === 0) { peg$fail(peg$e61); }
                                }
                                if (s1 !== peg$FAILED) {
                                  s2 = peg$currPos;
                                  peg$silentFails++;
                                  if (input.charCodeAt(peg$currPos) === 40) {
                                    s3 = peg$c19;
                                    peg$currPos++;
                                  } else {
                                    s3 = peg$FAILED;
                                    if (peg$silentFails === 0) { peg$fail(peg$e23); }
                                  }
                                  if (s3 === peg$FAILED) {
                                    s3 = peg$parseWhiteSpace();
                                    if (s3 === peg$FAILED) {
                                      s3 = peg$parseEOL();
                                    }
                                  }
                                  peg$silentFails--;
                                  if (s3 !== peg$FAILED) {
                                    peg$currPos = s2;
                                    s2 = undefined;
                                  } else {
                                    s2 = peg$FAILED;
                                  }
                                  if (s2 !== peg$FAILED) {
                                    peg$savedPos = s0;
                                    s0 = peg$f114();
                                  } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                  }
                                } else {
                                  peg$currPos = s0;
                                  s0 = peg$FAILED;
                                }
                                if (s0 === peg$FAILED) {
                                  s0 = peg$currPos;
                                  s1 = input.substr(peg$currPos, 4);
                                  if (s1.toLowerCase() === peg$c52) {
                                    peg$currPos += 4;
                                  } else {
                                    s1 = peg$FAILED;
                                    if (peg$silentFails === 0) { peg$fail(peg$e62); }
                                  }
                                  if (s1 !== peg$FAILED) {
                                    s2 = peg$currPos;
                                    peg$silentFails++;
                                    if (input.charCodeAt(peg$currPos) === 40) {
                                      s3 = peg$c19;
                                      peg$currPos++;
                                    } else {
                                      s3 = peg$FAILED;
                                      if (peg$silentFails === 0) { peg$fail(peg$e23); }
                                    }
                                    if (s3 === peg$FAILED) {
                                      s3 = peg$parseWhiteSpace();
                                      if (s3 === peg$FAILED) {
                                        s3 = peg$parseEOL();
                                      }
                                    }
                                    peg$silentFails--;
                                    if (s3 !== peg$FAILED) {
                                      peg$currPos = s2;
                                      s2 = undefined;
                                    } else {
                                      s2 = peg$FAILED;
                                    }
                                    if (s2 !== peg$FAILED) {
                                      peg$savedPos = s0;
                                      s0 = peg$f115();
                                    } else {
                                      peg$currPos = s0;
                                      s0 = peg$FAILED;
                                    }
                                  } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                  }
                                  if (s0 === peg$FAILED) {
                                    s0 = peg$currPos;
                                    s1 = input.substr(peg$currPos, 5);
                                    if (s1.toLowerCase() === peg$c53) {
                                      peg$currPos += 5;
                                    } else {
                                      s1 = peg$FAILED;
                                      if (peg$silentFails === 0) { peg$fail(peg$e63); }
                                    }
                                    if (s1 !== peg$FAILED) {
                                      s2 = peg$currPos;
                                      peg$silentFails++;
                                      if (input.charCodeAt(peg$currPos) === 40) {
                                        s3 = peg$c19;
                                        peg$currPos++;
                                      } else {
                                        s3 = peg$FAILED;
                                        if (peg$silentFails === 0) { peg$fail(peg$e23); }
                                      }
                                      if (s3 === peg$FAILED) {
                                        s3 = peg$parseWhiteSpace();
                                        if (s3 === peg$FAILED) {
                                          s3 = peg$parseEOL();
                                        }
                                      }
                                      peg$silentFails--;
                                      if (s3 !== peg$FAILED) {
                                        peg$currPos = s2;
                                        s2 = undefined;
                                      } else {
                                        s2 = peg$FAILED;
                                      }
                                      if (s2 !== peg$FAILED) {
                                        peg$savedPos = s0;
                                        s0 = peg$f116();
                                      } else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                      }
                                    } else {
                                      peg$currPos = s0;
                                      s0 = peg$FAILED;
                                    }
                                    if (s0 === peg$FAILED) {
                                      s0 = peg$currPos;
                                      s1 = input.substr(peg$currPos, 7);
                                      if (s1.toLowerCase() === peg$c54) {
                                        peg$currPos += 7;
                                      } else {
                                        s1 = peg$FAILED;
                                        if (peg$silentFails === 0) { peg$fail(peg$e64); }
                                      }
                                      if (s1 !== peg$FAILED) {
                                        s2 = peg$currPos;
                                        peg$silentFails++;
                                        if (input.charCodeAt(peg$currPos) === 40) {
                                          s3 = peg$c19;
                                          peg$currPos++;
                                        } else {
                                          s3 = peg$FAILED;
                                          if (peg$silentFails === 0) { peg$fail(peg$e23); }
                                        }
                                        if (s3 === peg$FAILED) {
                                          s3 = peg$parseWhiteSpace();
                                          if (s3 === peg$FAILED) {
                                            s3 = peg$parseEOL();
                                          }
                                        }
                                        peg$silentFails--;
                                        if (s3 !== peg$FAILED) {
                                          peg$currPos = s2;
                                          s2 = undefined;
                                        } else {
                                          s2 = peg$FAILED;
                                        }
                                        if (s2 !== peg$FAILED) {
                                          peg$savedPos = s0;
                                          s0 = peg$f117();
                                        } else {
                                          peg$currPos = s0;
                                          s0 = peg$FAILED;
                                        }
                                      } else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                      }
                                      if (s0 === peg$FAILED) {
                                        s0 = peg$currPos;
                                        s1 = input.substr(peg$currPos, 8);
                                        if (s1.toLowerCase() === peg$c55) {
                                          peg$currPos += 8;
                                        } else {
                                          s1 = peg$FAILED;
                                          if (peg$silentFails === 0) { peg$fail(peg$e65); }
                                        }
                                        if (s1 !== peg$FAILED) {
                                          s2 = peg$currPos;
                                          peg$silentFails++;
                                          if (input.charCodeAt(peg$currPos) === 40) {
                                            s3 = peg$c19;
                                            peg$currPos++;
                                          } else {
                                            s3 = peg$FAILED;
                                            if (peg$silentFails === 0) { peg$fail(peg$e23); }
                                          }
                                          if (s3 === peg$FAILED) {
                                            s3 = peg$parseWhiteSpace();
                                            if (s3 === peg$FAILED) {
                                              s3 = peg$parseEOL();
                                            }
                                          }
                                          peg$silentFails--;
                                          if (s3 !== peg$FAILED) {
                                            peg$currPos = s2;
                                            s2 = undefined;
                                          } else {
                                            s2 = peg$FAILED;
                                          }
                                          if (s2 !== peg$FAILED) {
                                            peg$savedPos = s0;
                                            s0 = peg$f118();
                                          } else {
                                            peg$currPos = s0;
                                            s0 = peg$FAILED;
                                          }
                                        } else {
                                          peg$currPos = s0;
                                          s0 = peg$FAILED;
                                        }
                                        if (s0 === peg$FAILED) {
                                          s0 = peg$currPos;
                                          s1 = input.substr(peg$currPos, 11);
                                          if (s1.toLowerCase() === peg$c56) {
                                            peg$currPos += 11;
                                          } else {
                                            s1 = peg$FAILED;
                                            if (peg$silentFails === 0) { peg$fail(peg$e66); }
                                          }
                                          if (s1 !== peg$FAILED) {
                                            s2 = peg$currPos;
                                            peg$silentFails++;
                                            if (input.charCodeAt(peg$currPos) === 40) {
                                              s3 = peg$c19;
                                              peg$currPos++;
                                            } else {
                                              s3 = peg$FAILED;
                                              if (peg$silentFails === 0) { peg$fail(peg$e23); }
                                            }
                                            if (s3 === peg$FAILED) {
                                              s3 = peg$parseWhiteSpace();
                                              if (s3 === peg$FAILED) {
                                                s3 = peg$parseEOL();
                                              }
                                            }
                                            peg$silentFails--;
                                            if (s3 !== peg$FAILED) {
                                              peg$currPos = s2;
                                              s2 = undefined;
                                            } else {
                                              s2 = peg$FAILED;
                                            }
                                            if (s2 !== peg$FAILED) {
                                              peg$savedPos = s0;
                                              s0 = peg$f119();
                                            } else {
                                              peg$currPos = s0;
                                              s0 = peg$FAILED;
                                            }
                                          } else {
                                            peg$currPos = s0;
                                            s0 = peg$FAILED;
                                          }
                                          if (s0 === peg$FAILED) {
                                            s0 = peg$parseTypeReferenceQuickSyntax();
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    return s0;
  }

  function peg$parseTypeReferenceQuickSyntax() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8;

    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 47) {
      s1 = peg$c57;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e67); }
    }
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$currPos;
      peg$silentFails++;
      if (input.charCodeAt(peg$currPos) === 40) {
        s5 = peg$c19;
        peg$currPos++;
      } else {
        s5 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e23); }
      }
      peg$silentFails--;
      if (s5 === peg$FAILED) {
        s4 = undefined;
      } else {
        peg$currPos = s4;
        s4 = peg$FAILED;
      }
      if (s4 !== peg$FAILED) {
        s5 = peg$currPos;
        peg$silentFails++;
        if (input.charCodeAt(peg$currPos) === 34) {
          s6 = peg$c32;
          peg$currPos++;
        } else {
          s6 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e40); }
        }
        peg$silentFails--;
        if (s6 === peg$FAILED) {
          s5 = undefined;
        } else {
          peg$currPos = s5;
          s5 = peg$FAILED;
        }
        if (s5 !== peg$FAILED) {
          s6 = peg$currPos;
          peg$silentFails++;
          if (input.charCodeAt(peg$currPos) === 61) {
            s7 = peg$c16;
            peg$currPos++;
          } else {
            s7 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$e19); }
          }
          peg$silentFails--;
          if (s7 === peg$FAILED) {
            s6 = undefined;
          } else {
            peg$currPos = s6;
            s6 = peg$FAILED;
          }
          if (s6 !== peg$FAILED) {
            s7 = peg$currPos;
            peg$silentFails++;
            if (input.charCodeAt(peg$currPos) === 60) {
              s8 = peg$c22;
              peg$currPos++;
            } else {
              s8 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$e27); }
            }
            peg$silentFails--;
            if (s8 === peg$FAILED) {
              s7 = undefined;
            } else {
              peg$currPos = s7;
              s7 = peg$FAILED;
            }
            if (s7 !== peg$FAILED) {
              s8 = peg$parseLineCharacter();
              if (s8 !== peg$FAILED) {
                s4 = [s4, s5, s6, s7, s8];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      if (s3 !== peg$FAILED) {
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$currPos;
          s4 = peg$currPos;
          peg$silentFails++;
          if (input.charCodeAt(peg$currPos) === 40) {
            s5 = peg$c19;
            peg$currPos++;
          } else {
            s5 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$e23); }
          }
          peg$silentFails--;
          if (s5 === peg$FAILED) {
            s4 = undefined;
          } else {
            peg$currPos = s4;
            s4 = peg$FAILED;
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$currPos;
            peg$silentFails++;
            if (input.charCodeAt(peg$currPos) === 34) {
              s6 = peg$c32;
              peg$currPos++;
            } else {
              s6 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$e40); }
            }
            peg$silentFails--;
            if (s6 === peg$FAILED) {
              s5 = undefined;
            } else {
              peg$currPos = s5;
              s5 = peg$FAILED;
            }
            if (s5 !== peg$FAILED) {
              s6 = peg$currPos;
              peg$silentFails++;
              if (input.charCodeAt(peg$currPos) === 61) {
                s7 = peg$c16;
                peg$currPos++;
              } else {
                s7 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$e19); }
              }
              peg$silentFails--;
              if (s7 === peg$FAILED) {
                s6 = undefined;
              } else {
                peg$currPos = s6;
                s6 = peg$FAILED;
              }
              if (s6 !== peg$FAILED) {
                s7 = peg$currPos;
                peg$silentFails++;
                if (input.charCodeAt(peg$currPos) === 60) {
                  s8 = peg$c22;
                  peg$currPos++;
                } else {
                  s8 = peg$FAILED;
                  if (peg$silentFails === 0) { peg$fail(peg$e27); }
                }
                peg$silentFails--;
                if (s8 === peg$FAILED) {
                  s7 = undefined;
                } else {
                  peg$currPos = s7;
                  s7 = peg$FAILED;
                }
                if (s7 !== peg$FAILED) {
                  s8 = peg$parseLineCharacter();
                  if (s8 !== peg$FAILED) {
                    s4 = [s4, s5, s6, s7, s8];
                    s3 = s4;
                  } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s3;
                  s3 = peg$FAILED;
                }
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        }
      } else {
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f120();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseCardinality() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9;

    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 40) {
      s1 = peg$c19;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e23); }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseUnsignedNumber();
      if (s3 === peg$FAILED) {
        s3 = input.charAt(peg$currPos);
        if (s3.toLowerCase() === peg$c58) {
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e68); }
        }
      }
      if (s3 === peg$FAILED) {
        s3 = null;
      }
      s4 = peg$parse__();
      if (input.charCodeAt(peg$currPos) === 45) {
        s5 = peg$c21;
        peg$currPos++;
      } else {
        s5 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e26); }
      }
      if (s5 !== peg$FAILED) {
        s6 = peg$parse__();
        s7 = peg$parseUnsignedNumber();
        if (s7 === peg$FAILED) {
          s7 = input.charAt(peg$currPos);
          if (s7.toLowerCase() === peg$c58) {
            peg$currPos++;
          } else {
            s7 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$e68); }
          }
        }
        if (s7 !== peg$FAILED) {
          s8 = peg$parse__();
          if (input.charCodeAt(peg$currPos) === 41) {
            s9 = peg$c20;
            peg$currPos++;
          } else {
            s9 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$e24); }
          }
          if (s9 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f121(s3, s7);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 40) {
        s1 = peg$c19;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e23); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse__();
        s3 = peg$parseUnsignedNumber();
        if (s3 === peg$FAILED) {
          s3 = input.charAt(peg$currPos);
          if (s3.toLowerCase() === peg$c58) {
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$e68); }
          }
        }
        if (s3 !== peg$FAILED) {
          s4 = peg$parse__();
          if (input.charCodeAt(peg$currPos) === 45) {
            s5 = peg$c21;
            peg$currPos++;
          } else {
            s5 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$e26); }
          }
          if (s5 !== peg$FAILED) {
            s6 = peg$parse__();
            s7 = peg$parseUnsignedNumber();
            if (s7 === peg$FAILED) {
              s7 = input.charAt(peg$currPos);
              if (s7.toLowerCase() === peg$c58) {
                peg$currPos++;
              } else {
                s7 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$e68); }
              }
            }
            if (s7 === peg$FAILED) {
              s7 = null;
            }
            s8 = peg$parse__();
            if (input.charCodeAt(peg$currPos) === 41) {
              s9 = peg$c20;
              peg$currPos++;
            } else {
              s9 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$e24); }
            }
            if (s9 !== peg$FAILED) {
              peg$savedPos = s0;
              s0 = peg$f122(s3, s7);
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 40) {
          s1 = peg$c19;
          peg$currPos++;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e23); }
        }
        if (s1 !== peg$FAILED) {
          s2 = peg$parse__();
          s3 = peg$parseUnsignedNumber();
          if (s3 === peg$FAILED) {
            s3 = input.charAt(peg$currPos);
            if (s3.toLowerCase() === peg$c58) {
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$e68); }
            }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse__();
            if (input.charCodeAt(peg$currPos) === 41) {
              s5 = peg$c20;
              peg$currPos++;
            } else {
              s5 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$e24); }
            }
            if (s5 !== peg$FAILED) {
              peg$savedPos = s0;
              s0 = peg$f123(s3);
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      }
    }

    return s0;
  }

  function peg$parseFormula() {
    var s0, s1, s2, s3, s4;

    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 61) {
      s1 = peg$c16;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e19); }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = [];
      s4 = input.charAt(peg$currPos);
      if (peg$r10.test(s4)) {
        peg$currPos++;
      } else {
        s4 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e69); }
      }
      if (s4 === peg$FAILED) {
        if (input.substr(peg$currPos, 2) === peg$c33) {
          s4 = peg$c33;
          peg$currPos += 2;
        } else {
          s4 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e41); }
        }
      }
      while (s4 !== peg$FAILED) {
        s3.push(s4);
        s4 = input.charAt(peg$currPos);
        if (peg$r10.test(s4)) {
          peg$currPos++;
        } else {
          s4 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e69); }
        }
        if (s4 === peg$FAILED) {
          if (input.substr(peg$currPos, 2) === peg$c33) {
            s4 = peg$c33;
            peg$currPos += 2;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$e41); }
          }
        }
      }
      peg$savedPos = s0;
      s0 = peg$f124(s3);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseQuickHelp() {
    var s0, s1, s2, s3;

    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 34) {
      s1 = peg$c32;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e40); }
    }
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = input.charAt(peg$currPos);
      if (peg$r8.test(s3)) {
        peg$currPos++;
      } else {
        s3 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e42); }
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = input.charAt(peg$currPos);
        if (peg$r8.test(s3)) {
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e42); }
        }
      }
      if (input.charCodeAt(peg$currPos) === 34) {
        s3 = peg$c32;
        peg$currPos++;
      } else {
        s3 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e40); }
      }
      if (s3 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f125(s2);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseTypeSettings() {
    var s0, s1;

    s0 = peg$currPos;
    s1 = peg$parseTypeSettingSets();
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f126(s1);
    }
    s0 = s1;

    return s0;
  }

  function peg$parseTypeSettingSets() {
    var s0, s1, s2, s3, s4, s5;

    s0 = peg$currPos;
    s1 = peg$parseLabeledTypeSettingsBlock();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = [];
      s5 = peg$parseEmptyLine();
      if (s5 !== peg$FAILED) {
        while (s5 !== peg$FAILED) {
          s4.push(s5);
          s5 = peg$parseEmptyLine();
        }
      } else {
        s4 = peg$FAILED;
      }
      if (s4 !== peg$FAILED) {
        s5 = peg$parseLabeledTypeSettingsBlock();
        if (s5 !== peg$FAILED) {
          peg$savedPos = s3;
          s3 = peg$f127(s1, s5);
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = [];
        s5 = peg$parseEmptyLine();
        if (s5 !== peg$FAILED) {
          while (s5 !== peg$FAILED) {
            s4.push(s5);
            s5 = peg$parseEmptyLine();
          }
        } else {
          s4 = peg$FAILED;
        }
        if (s4 !== peg$FAILED) {
          s5 = peg$parseLabeledTypeSettingsBlock();
          if (s5 !== peg$FAILED) {
            peg$savedPos = s3;
            s3 = peg$f127(s1, s5);
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f128(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseDefaultTypeSettingsBlock();
      if (s1 !== peg$FAILED) {
        s2 = [];
        s3 = peg$currPos;
        s4 = [];
        s5 = peg$parseEmptyLine();
        if (s5 !== peg$FAILED) {
          while (s5 !== peg$FAILED) {
            s4.push(s5);
            s5 = peg$parseEmptyLine();
          }
        } else {
          s4 = peg$FAILED;
        }
        if (s4 !== peg$FAILED) {
          s5 = peg$parseLabeledTypeSettingsBlock();
          if (s5 !== peg$FAILED) {
            peg$savedPos = s3;
            s3 = peg$f129(s1, s5);
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$currPos;
          s4 = [];
          s5 = peg$parseEmptyLine();
          if (s5 !== peg$FAILED) {
            while (s5 !== peg$FAILED) {
              s4.push(s5);
              s5 = peg$parseEmptyLine();
            }
          } else {
            s4 = peg$FAILED;
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parseLabeledTypeSettingsBlock();
            if (s5 !== peg$FAILED) {
              peg$savedPos = s3;
              s3 = peg$f129(s1, s5);
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        }
        peg$savedPos = s0;
        s0 = peg$f130(s1, s2);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }

    return s0;
  }

  function peg$parseDefaultTypeSettingsBlock() {
    var s0, s1, s2;

    s0 = peg$currPos;
    s1 = [];
    s2 = peg$parseTypeSettingsLine();
    if (s2 !== peg$FAILED) {
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parseTypeSettingsLine();
      }
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f131(s1);
    }
    s0 = s1;

    return s0;
  }

  function peg$parseLabeledTypeSettingsBlock() {
    var s0, s1, s2, s3;

    s0 = peg$currPos;
    s1 = peg$parseTypeSettingsLabel();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$parseTypeSettingsLineOrEmptyLine();
      if (s3 !== peg$FAILED) {
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$parseTypeSettingsLineOrEmptyLine();
        }
      } else {
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f132(s1, s2);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseTypeSettingsLineOrEmptyLine() {
    var s0, s1, s2, s3, s4;

    s0 = peg$currPos;
    s1 = peg$currPos;
    peg$silentFails++;
    s2 = peg$parseTypeSettingsLabel();
    peg$silentFails--;
    if (s2 === peg$FAILED) {
      s1 = undefined;
    } else {
      peg$currPos = s1;
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$parseEmptyLine();
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$parseEmptyLine();
      }
      s3 = peg$currPos;
      peg$silentFails++;
      s4 = peg$parseTypeSettingsLabel();
      peg$silentFails--;
      if (s4 === peg$FAILED) {
        s3 = undefined;
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      if (s3 !== peg$FAILED) {
        s4 = peg$parseTypeSettingsLine();
        if (s4 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f133(s4);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseTypeSettingsLine() {
    var s0, s1, s2, s3;

    s0 = peg$currPos;
    s1 = peg$parseIndent();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$parseLineCharacter();
      if (s3 !== peg$FAILED) {
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$parseLineCharacter();
        }
      } else {
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parseEOL();
        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f134(s2);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseTypeSettingsLabel() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13, s14, s15;

    s0 = peg$currPos;
    s1 = peg$parseIndent();
    if (s1 !== peg$FAILED) {
      s2 = peg$parseIdentifierAllowingDashes();
      if (s2 !== peg$FAILED) {
        s3 = peg$parse__();
        if (input.charCodeAt(peg$currPos) === 40) {
          s4 = peg$c19;
          peg$currPos++;
        } else {
          s4 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e23); }
        }
        if (s4 !== peg$FAILED) {
          s5 = peg$parse__();
          s6 = peg$parseTypeSettingsSectionParam();
          if (s6 === peg$FAILED) {
            s6 = null;
          }
          s7 = peg$parse__();
          if (input.charCodeAt(peg$currPos) === 41) {
            s8 = peg$c20;
            peg$currPos++;
          } else {
            s8 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$e24); }
          }
          if (s8 !== peg$FAILED) {
            s9 = peg$parse__();
            if (input.charCodeAt(peg$currPos) === 58) {
              s10 = peg$c18;
              peg$currPos++;
            } else {
              s10 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$e21); }
            }
            if (s10 !== peg$FAILED) {
              s11 = peg$parseEOL();
              if (s11 !== peg$FAILED) {
                s12 = peg$parseIndent();
                if (s12 !== peg$FAILED) {
                  if (input.substr(peg$currPos, 3) === peg$c1) {
                    s13 = peg$c1;
                    peg$currPos += 3;
                  } else {
                    s13 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$e1); }
                  }
                  if (s13 !== peg$FAILED) {
                    s14 = [];
                    if (input.charCodeAt(peg$currPos) === 45) {
                      s15 = peg$c21;
                      peg$currPos++;
                    } else {
                      s15 = peg$FAILED;
                      if (peg$silentFails === 0) { peg$fail(peg$e26); }
                    }
                    while (s15 !== peg$FAILED) {
                      s14.push(s15);
                      if (input.charCodeAt(peg$currPos) === 45) {
                        s15 = peg$c21;
                        peg$currPos++;
                      } else {
                        s15 = peg$FAILED;
                        if (peg$silentFails === 0) { peg$fail(peg$e26); }
                      }
                    }
                    peg$savedPos = s0;
                    s0 = peg$f135(s2, s6);
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseIndent();
      if (s1 !== peg$FAILED) {
        s2 = peg$parseIdentifierAllowingDashes();
        if (s2 !== peg$FAILED) {
          s3 = peg$parse__();
          if (input.charCodeAt(peg$currPos) === 58) {
            s4 = peg$c18;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$e21); }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parseEOL();
            if (s5 !== peg$FAILED) {
              s6 = peg$parseIndent();
              if (s6 !== peg$FAILED) {
                if (input.substr(peg$currPos, 3) === peg$c1) {
                  s7 = peg$c1;
                  peg$currPos += 3;
                } else {
                  s7 = peg$FAILED;
                  if (peg$silentFails === 0) { peg$fail(peg$e1); }
                }
                if (s7 !== peg$FAILED) {
                  s8 = [];
                  if (input.charCodeAt(peg$currPos) === 45) {
                    s9 = peg$c21;
                    peg$currPos++;
                  } else {
                    s9 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$e26); }
                  }
                  while (s9 !== peg$FAILED) {
                    s8.push(s9);
                    if (input.charCodeAt(peg$currPos) === 45) {
                      s9 = peg$c21;
                      peg$currPos++;
                    } else {
                      s9 = peg$FAILED;
                      if (peg$silentFails === 0) { peg$fail(peg$e26); }
                    }
                  }
                  s9 = peg$parseEOL();
                  if (s9 !== peg$FAILED) {
                    s10 = peg$currPos;
                    peg$silentFails++;
                    s11 = peg$parseIndent();
                    peg$silentFails--;
                    if (s11 !== peg$FAILED) {
                      peg$currPos = s10;
                      s10 = undefined;
                    } else {
                      s10 = peg$FAILED;
                    }
                    if (s10 !== peg$FAILED) {
                      peg$savedPos = s0;
                      s0 = peg$f136(s2);
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }

    return s0;
  }

  function peg$parseSignedNumber() {
    var s0, s1, s2, s3;

    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 45) {
      s1 = peg$c21;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e26); }
    }
    if (s1 === peg$FAILED) {
      s1 = null;
    }
    s2 = [];
    s3 = input.charAt(peg$currPos);
    if (peg$r11.test(s3)) {
      peg$currPos++;
    } else {
      s3 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e70); }
    }
    if (s3 !== peg$FAILED) {
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = input.charAt(peg$currPos);
        if (peg$r11.test(s3)) {
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e70); }
        }
      }
    } else {
      s2 = peg$FAILED;
    }
    if (s2 !== peg$FAILED) {
      peg$savedPos = s0;
      s0 = peg$f137(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseUnsignedNumber() {
    var s0, s1, s2;

    s0 = peg$currPos;
    s1 = [];
    s2 = input.charAt(peg$currPos);
    if (peg$r11.test(s2)) {
      peg$currPos++;
    } else {
      s2 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e70); }
    }
    if (s2 !== peg$FAILED) {
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = input.charAt(peg$currPos);
        if (peg$r11.test(s2)) {
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e70); }
        }
      }
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f138(s1);
    }
    s0 = s1;

    return s0;
  }

  function peg$parseEmptyLine() {
    var s0, s1, s2, s3;

    s0 = peg$currPos;
    s1 = [];
    s2 = peg$parseWhiteSpace();
    while (s2 !== peg$FAILED) {
      s1.push(s2);
      s2 = peg$parseWhiteSpace();
    }
    s2 = peg$parseLineTerminatorSequence();
    if (s2 !== peg$FAILED) {
      peg$savedPos = peg$currPos;
      s3 = peg$f139(s1);
      if (s3) {
        s3 = undefined;
      } else {
        s3 = peg$FAILED;
      }
      if (s3 !== peg$FAILED) {
        s1 = [s1, s2, s3];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$parseLineTerminatorSequence();
    }

    return s0;
  }

  function peg$parseDoubleEmptyLine() {
    var s0, s1, s2;

    s0 = peg$currPos;
    s1 = peg$parseEmptyLine();
    if (s1 !== peg$FAILED) {
      s2 = peg$parseEmptyLine();
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseEndOfIndent() {
    var s0, s1, s2, s3, s4;

    s0 = peg$currPos;
    s1 = peg$parseEmptyLine();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$parseEmptyLine();
      if (s3 !== peg$FAILED) {
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$parseEmptyLine();
        }
      } else {
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$currPos;
        peg$silentFails++;
        s4 = peg$parseWhiteSpace();
        peg$silentFails--;
        if (s4 === peg$FAILED) {
          s3 = undefined;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
        if (s3 !== peg$FAILED) {
          s1 = [s1, s2, s3];
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parseEmptyLine();
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$parseEmptyLine();
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$currPos;
        peg$silentFails++;
        if (input.length > peg$currPos) {
          s3 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e71); }
        }
        peg$silentFails--;
        if (s3 === peg$FAILED) {
          s2 = undefined;
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
          s1 = [s1, s2];
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }

    return s0;
  }

  function peg$parseTextLine() {
    var s0, s1, s2;

    s0 = peg$currPos;
    s1 = [];
    s2 = peg$parseLineCharacter();
    if (s2 !== peg$FAILED) {
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parseLineCharacter();
      }
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parseLineTerminatorSequence();
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f140(s1);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parse__() {
    var s0, s1;

    s0 = [];
    s1 = peg$parseWhiteSpace();
    while (s1 !== peg$FAILED) {
      s0.push(s1);
      s1 = peg$parseWhiteSpace();
    }

    return s0;
  }

  function peg$parseEOB() {
    var s0, s1, s2, s3;

    peg$silentFails++;
    s0 = peg$currPos;
    s1 = peg$parseEOL();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$parseEOL();
      if (s3 !== peg$FAILED) {
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$parseEOL();
        }
      } else {
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$silentFails--;
    if (s0 === peg$FAILED) {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e72); }
    }

    return s0;
  }

  function peg$parseEOL() {
    var s0, s1, s2;

    peg$silentFails++;
    s0 = peg$currPos;
    s1 = peg$parse__();
    s2 = peg$parseLineTerminatorSequence();
    if (s2 !== peg$FAILED) {
      s1 = [s1, s2];
      s0 = s1;
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$silentFails--;
    if (s0 === peg$FAILED) {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e73); }
    }

    return s0;
  }

  function peg$parseEOF() {
    var s0, s1;

    s0 = peg$currPos;
    peg$silentFails++;
    if (input.length > peg$currPos) {
      s1 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e71); }
    }
    peg$silentFails--;
    if (s1 === peg$FAILED) {
      s0 = undefined;
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseIndent() {
    var s0;

    if (input.charCodeAt(peg$currPos) === 9) {
      s0 = peg$c59;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e74); }
    }
    if (s0 === peg$FAILED) {
      if (input.substr(peg$currPos, 2) === peg$c60) {
        s0 = peg$c60;
        peg$currPos += 2;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e75); }
      }
    }

    return s0;
  }

  function peg$parseWhiteSpace() {
    var s0, s1;

    peg$silentFails++;
    s0 = input.charAt(peg$currPos);
    if (peg$r12.test(s0)) {
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e77); }
    }
    peg$silentFails--;
    if (s0 === peg$FAILED) {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e76); }
    }

    return s0;
  }

  function peg$parseLineTerminator() {
    var s0;

    s0 = input.charAt(peg$currPos);
    if (peg$r13.test(s0)) {
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e78); }
    }

    return s0;
  }

  function peg$parseLineTerminatorSequence() {
    var s0, s1;

    peg$silentFails++;
    if (input.charCodeAt(peg$currPos) === 10) {
      s0 = peg$c61;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e80); }
    }
    if (s0 === peg$FAILED) {
      if (input.substr(peg$currPos, 2) === peg$c62) {
        s0 = peg$c62;
        peg$currPos += 2;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e81); }
      }
      if (s0 === peg$FAILED) {
        if (input.charCodeAt(peg$currPos) === 13) {
          s0 = peg$c63;
          peg$currPos++;
        } else {
          s0 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e82); }
        }
      }
    }
    peg$silentFails--;
    if (s0 === peg$FAILED) {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e79); }
    }

    return s0;
  }

  function peg$parseLineCharacter() {
    var s0, s1, s2;

    s0 = peg$currPos;
    s1 = peg$currPos;
    peg$silentFails++;
    s2 = peg$parseLineTerminator();
    peg$silentFails--;
    if (s2 === peg$FAILED) {
      s1 = undefined;
    } else {
      peg$currPos = s1;
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      if (input.length > peg$currPos) {
        s2 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e71); }
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f141(s2);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }


  var result = {
    definition: null,
    sections: [],
    fields: {},
    placeholders: [],
    conditions: {},
    hints: [],
    //typePositions: [],
    log: ""
  }

  var nextConditionId=0;
  var unitStyleParameters = new Set(['x','y','w','h']);

  // Well-known tags can be suggested when a parsed tag looks like a typo.
  var wellKnownTags = new Set([
    'required',
    'optional',
    'sanitize',
    'format',
    'normalize',
    'help',
    'hint',
    'readonly',
    'hidden',
    'disabled',
    'placeholder',
    'min',
    'max',
    'step',
    'pattern',
    'validate',
    'transform',
    'label',
    'description',
    'unit',
    'precision',
    'rows',
    'cols',
    'multiline',
    'autogrow',
    'allow-custom',
  ]);

  // Simple Levenshtein distance for similarity detection
  function levenshteinDistance(a, b) {
    if (a.length === 0) return b.length;
    if (b.length === 0) return a.length;

    var matrix = [];
    for (var i = 0; i <= b.length; i++) {
      matrix[i] = [i];
    }
    for (var j = 0; j <= a.length; j++) {
      matrix[0][j] = j;
    }

    for (var i = 1; i <= b.length; i++) {
      for (var j = 1; j <= a.length; j++) {
        if (b.charAt(i - 1) === a.charAt(j - 1)) {
          matrix[i][j] = matrix[i - 1][j - 1];
        } else {
          matrix[i][j] = Math.min(
            matrix[i - 1][j - 1] + 1,
            matrix[i][j - 1] + 1,
            matrix[i - 1][j] + 1
          );
        }
      }
    }

    return matrix[b.length][a.length];
  }

  // Find similar known tag
  function findSimilarTag(tagName) {
    var lowerTag = tagName.toLowerCase();
    var bestMatch = null;
    var bestDistance = Infinity;

    wellKnownTags.forEach(function(wellKnownTag) {
      var distance = levenshteinDistance(lowerTag, wellKnownTag);
      // Only suggest if distance is small relative to tag length (max 2 edits for short tags, 3 for longer)
      var maxDistance = Math.min(3, Math.ceil(wellKnownTag.length / 3));
      if (distance > 0 && distance <= maxDistance && distance < bestDistance) {
        bestDistance = distance;
        bestMatch = wellKnownTag;
      }
    });

    return bestMatch;
  }

  // Check tag and add hint if needed
  function checkTagHint(tagName, fieldName, offset) {
    if (wellKnownTags.has(tagName.toLowerCase())) {
      return; // Exact well-known tag, no hint needed
    }

    var similar = findSimilarTag(tagName);
    if (similar) {
      result.hints.push({
        type: 'unknown-tag',
        tag: tagName,
        field: fieldName,
        suggestion: similar,
        message: "Unknown tag '" + tagName + "'. Did you mean '" + similar + "'?",
        range: {
          from: offset,
          to: offset + tagName.length
        }
      });
    }
  }

  var supportedFieldTypes = new Set([
    'text',
    'password',
    'number',
    'select',
    'switch',
    'date',
    'datetime',
    'mail',
    'dayofyear',
    'monthofyear',
    'month',
    'year',
    'time',
    'duration',
    'ref',
    'file',
    'image',
    'address',
    'currency',
    'geolocation',
  ]);

  function addUnsupportedFieldTypeHints(definition) {
    var declaration = /^(\s*)\[([a-z_][a-z0-9_]*)\]\s*:\s*(?:"([a-z][a-z0-9_]*)"|([a-z][a-z0-9_]*))/gim;
    var match;

    while ((match = declaration.exec(definition)) !== null) {
      var fieldName = match[2];
      var fieldType = match[3] || match[4];

      if (supportedFieldTypes.has(fieldType.toLowerCase())) {
        continue;
      }

      var typeOffset = match.index + match[0].lastIndexOf(fieldType);
      result.hints.push({
        type: 'unsupported-field-type',
        tag: fieldType,
        field: fieldName,
        suggestion: 'Text',
        message: "Unsupported field type '" + fieldType + "'. This line is treated as text. Use 'Text' to store serialized JSON.",
        range: {
          from: typeOffset,
          to: typeOffset + fieldType.length
        }
      });
    }
  }

  function createCondition(expression) {
    assertConditionExpression(expression);

    var cid = 'cond' + nextConditionId++;
    var condition = {
      id: cid,
      expression: expression
    };
    result.conditions[cid] = expression;
    return condition;
  }

  function assertConditionExpression(expression) {
    var quote = null;
    var escaped = false;

    for (var i = 0; i < expression.length; i++) {
      var character = expression[i];

      if (escaped) {
        escaped = false;
        continue;
      }

      if (character === '\\') {
        escaped = true;
        continue;
      }

      if (quote) {
        if (character === quote) {
          quote = null;
        }

        continue;
      }

      if (character === '"' || character === "'" || character === '`') {
        quote = character;
      }
    }

    if (quote) {
      error('Unterminated string literal in condition expression: ' + expression);
    }
  }

  function setTagValue(tags, key, value) {
    if ((key === 'sanitize' || key === 'format') && typeof tags[key] === 'string' && typeof value === 'string') {
      tags[key] = tags[key] + ',' + value;
    } else {
      tags[key] = value;
    }
  }

  function mergeTagGroups(tagGroups) {
    var tags = {};
    var tagsMeta = [];

    for (var group of tagGroups || []) {
      if (!group) {
        continue;
      }

      for (var key of Object.keys(group)) {
        if (key === '_tagsMeta') {
          tagsMeta = tagsMeta.concat(group._tagsMeta || []);
        } else if (key === '_fieldCondition') {
          tags._fieldCondition = group._fieldCondition;
        } else {
          setTagValue(tags, key, group[key]);
        }
      }
    }

    if (tagsMeta.length > 0) {
      tags._tagsMeta = tagsMeta;
    }

    return tags;
  }
  
  addSection(0, 0, {offset:0, level:0, title:'', type:'ROOT', directives:[]});
  
  function addSection(tokenOffset, tokenLength, section){

    if(currentSection() && section.level > currentSection().level+1){
      var virtualSection = {
        offset: section.offset,
        level: section.level-1,
        title: '',
        type: 'VIRTUAL',
        directives: []
      }
      addSection(tokenOffset, 0, virtualSection);
    }
  
    // close previous section:
    if(section.type !== "ROOT"){
      var previousSection = currentSection();
      previousSection.length = tokenOffset - previousSection.offset;
    }
  
    var newSection = {
      offset: tokenOffset,
      offsetExcludeDirectives: section.offset,
      offsetExcludeTitle: tokenOffset+tokenLength,
      length: null,
      lengthIncludeSubsections: null,
   
      level: section.level,
      title: section.title,
      type: section.type,
      style: {},
      tags: {},
      
      placeholders: [],
      paragraphs: []
    };
    
    applyDirectives(newSection, section.directives);
    newSection.index = result.sections.length;
    result.sections.push(newSection);
    addNextParagraph();
  }
  
  function currentSection(){
    return result.sections[result.sections.length-1];
  }
  
  function addNextParagraph(){
    var newParagraph = {
      offset: null,
      length: null,
      hasText: false,
      hasPlaceholders: false,
      placeholders: [],
      style: {}
    };
    
    currentSection().paragraphs.push(newParagraph);
  }
  
  function completeCurrentParagraph(tokenOffset, tokenLength, offsetExcludeDirectives, directives){
    if(currentParagraph() && !currentParagraph().length){
      currentParagraph().offset = tokenOffset;
      currentParagraph().offsetExcludeDirectives = offsetExcludeDirectives;
      currentParagraph().length = tokenLength;
      
      applyDirectives(currentParagraph(), directives)
    }
  }
  
  function currentParagraph(){
    if(currentSection() && currentSection().paragraphs.length > 0)
      return currentSection().paragraphs[currentSection().paragraphs.length-1];
    else
      return undefined;
  }
  
  function getField(fieldName){
    
    if(!result.fields[fieldName]){
      var newField = {
        name: fieldName,
        cardinality: null,
        defaultValue: null,
        description: null,
        filter: null,
        required: false,
        type: null,
        subType: null
      };
      
      result.fields[fieldName] = newField;
      addTypeDefinitionToField(fieldName, {});
    }
    
    return result.fields[fieldName];
  }
  
  
  function addPlaceholder(tokenOffset, tokenLength, directives, fieldName, label){
    var field = null;
    
    if(fieldName) {
      // var newPosition = {
      //   offset: tokenOffset,
      //   length: tokenLength,
      //   label: label,
      //   control: null,
      //   style: {}
      // } 
     
      field = getField(fieldName);
      //applyDirectives(newPosition, directives);    
      //field.positions.push(newPosition);
    }

    var newPlaceholder = {
      field: field,
      offset: tokenOffset,
      length: tokenLength,
      label: label,
      control: null,
      style: {}
    }
    
    if(directives)
      applyDirectives(newPlaceholder, directives);
    
    newPlaceholder.index = result.placeholders.length;
    result.placeholders.push(newPlaceholder);
    currentSection().placeholders.push(newPlaceholder);
    currentParagraph().placeholders.push(newPlaceholder);
    currentParagraph().hasPlaceholders = true;
  }

  function addConsumedRange(offset, length){
    if(typeof offset === 'number' && typeof length === 'number' && length > 0){
      result.placeholders.push({ offset: offset, length: length });
    }
  }
  
  function applyDirectives(item, directives){
    directives.forEach(function(directive){      
      // convert convenience negations of readonly and hide
      if((directive.type === "STYLE") && (directive.condition)){
      	if(directive.params[0] === "show"){
        	directive.params[0] = "hidden";
            directive.condition = "!(" + directive.condition + ")";
        }
        else if(directive.params[0] === "editable"){
        	directive.params[0] = "readonly";
            directive.condition = "!(" + directive.condition + ")";
        }
      }
      
      // hide is now also allowed as an alias for hidden
      if((directive.type === "STYLE") && (directive.params[0] === "hide")){
      	directive.params[0] = "hidden"
      }
    
      var condition;
      
      if(directive.condition){
        condition = createCondition(directive.condition);
      }
    
      if(directive.type === "CONTROL"){
        var hasControlName = directive.controlFullName !== undefined;
        var inheritedParameters = {};

        if(hasControlName && item.control && !item.control.name && !item.control.fullName && item.control.parameters){
          inheritedParameters = item.control.parameters;
        }

        var newControl = hasControlName ? {
          namespace: directive.controlNamespace,
          name: directive.controlName,
          fullName: directive.controlFullName,
          parameters: {}
        } : item.control || { parameters: {} };

        if(!newControl.parameters)
          newControl.parameters = {};

        for(var inheritedParamName in inheritedParameters){
          newControl.parameters[inheritedParamName] = inheritedParameters[inheritedParamName];
        }
        
        if(condition)
          newControl.condition = condition;
        
        directive.params.forEach(function(param){
          var newParam = {
            value: param.value
          }
          
          if(param.field)
            newParam.field = param.field;

          if(param.path)
            newParam.path = param.path;
            
          newControl.parameters[param.name] = newParam;
        });
        
        item.control = newControl;
      }
      else if(directive.type === "STYLE"){
        if(!item.style){
          item.style = {};
        }
        
        directive.params.forEach(function(param){
          var propertyName = getPropertyNameForStyle(item.style, param)

          item.style[propertyName] = { value: getStyleValue(param) };
          
          if(condition)
            item.style[propertyName].condition = condition;
        });
      } else if (directive.type === 'TAGS') {
        const tags = item.tags ?? {}
        item.tags = { ...tags, ...directive.tags };
        applyTagStyles(item, directive.tags, condition);
      }
    });
  }
  
  function getStyleValue(param){
    if(param && typeof param === 'object' && Object.prototype.hasOwnProperty.call(param, 'value')){
      return normalizeStyleValue(param);
    }

    return true;
  }

  function normalizeStyleValue(param){
    var value = param.value;
    if(value == null){
      return true;
    }

    var name = (param.name || '').toLowerCase();
    if(unitStyleParameters.has(name)){
      return normalizeUnitStyleValue(value);
    }
    
    return value;
  }

  function normalizeUnitStyleValue(value){
    if(value == null){
      return value;
    }

    if(typeof value === 'number'){
      if(Number.isNaN(value)){
        return value;
      }
      return value + '%';
    }

    if(typeof value === 'string'){
      var trimmed = value.trim();
      if(trimmed.length === 0){
        return trimmed;
      }

      if(hasCssUnit(trimmed)){
        return trimmed;
      }

      if(isNumeric(trimmed)){
        return trimmed + '%';
      }

      return trimmed;
    }

    return value;
  }

  function hasCssUnit(value){
    var lastChar = value[value.length - 1];
    return /[a-zA-Z%]/.test(lastChar);
  }

  function isNumeric(value){
    return /^-?\d+(\.\d+)?$/.test(value);
  }

  function applyTagStyles(item, tags, condition){
    if(!tags){
      return;
    }

    if(!item.style){
      item.style = {};
    }

    Object.keys(tags).forEach(function(tagName){
      var param = { name: tagName, value: tags[tagName] };
      var propertyName = getPropertyNameForStyle(item.style, param);

      item.style[propertyName] = { value: getStyleValue(param) };

      if(condition){
        item.style[propertyName].condition = condition;
      }
    });
  }

  
  function getPropertyNameForStyle(item, param){
  	let counter = 1;
    let paramName = param.name ?? param;
    var propertyName = paramName;
    
    while(item.hasOwnProperty(propertyName)){
      propertyName = paramName + '-' + counter++; 
    }
    
    return propertyName;
  }
  
  function addTypeDefinition(tokenOffset, tokenLength, fieldName, typeDefinition){
    addTypeDefinitionToField(fieldName, typeDefinition);
    
    var newTypePosition = {
      offset: tokenOffset,
      length: tokenLength
    };
    
    result.placeholders.push(newTypePosition)
  }
  
  function addTypeDefinitionToField(fieldName, typeDefinition){
    var field = getField(fieldName);

    if( !field.typeDefinition
     || (field.typeDefinition.typeReference && typeDefinition.typeReference && (field.typeDefinition.typeReference != typeDefinition.typeReference))
     || ((field.typeDefinition.cardinality||{}).min != (typeDefinition.cardinality||{}).min)
     || ((field.typeDefinition.cardinality||{}).max != (typeDefinition.cardinality||{}).max)
     || (field.typeDefinition.required != typeDefinition.required ))
    {
      // completely reset the typeDefinition if the typeReference or cardinality differs from
      // former specification
      // TODO: deep-check tags array
      field.typeDefinition = {}
    }
   
    if(typeDefinition.typeReference){
      field.typeDefinition.typeReference = typeDefinition.typeReference;

      if(typeDefinition.typeReference === 'QUICKSYNTAXTYPE'){
        field.typeDefinition.quickSyntaxText = typeDefinition.quickSyntaxText;
      }
    }
    
    field.typeDefinition.help = typeDefinition.help
    field.typeDefinition.required = typeDefinition.required
    field.typeDefinition.cardinality = typeDefinition.cardinality;

    if(typeDefinition.condition){
      field.condition = createCondition(typeDefinition.condition);
    } else {
      delete field.condition;
    }

    // Check tags for hints before assigning
    var tags = typeDefinition.tags || {};
    if (tags._tagsMeta) {
      tags._tagsMeta.forEach(function(meta) {
        checkTagHint(meta.name, fieldName, meta.offset);
      });
      // Remove metadata from final tags object
      delete tags._tagsMeta;
    }
    field.tags = tags;

     for (let tag of ['required','optional']) {
      if (typeof field.tags[tag] === 'string') {
        field.tags[tag] = {
          expression: field.tags[tag]
        }
      } else if (field.tags[tag]?.condition) {
        field.tags[tag] = {
          expression: field.tags[tag].condition
        }
      }
    }
    
    if(typeDefinition.defaultDirectives){
      
      if(!field.typeDefinition.defaultDirectives){
        field.typeDefinition.defaultDirectives = {};
      }
      
      if(typeDefinition.defaultDirectives.control){
        field.typeDefinition.defaultDirectives.control = typeDefinition.defaultDirectives.control;
      }
      
      if(typeDefinition.defaultDirectives.style){
        if(!field.typeDefinition.defaultDirectives.style){
          field.typeDefinition.defaultDirectives.style = {};
        }
      
        for(var styleName in typeDefinition.defaultDirectives.style){
          field.typeDefinition.defaultDirectives.style[styleName] = typeDefinition.defaultDirectives.style[styleName];
        }
      }
      //field.typeDefinition.defaultDirectives = typeDefinition.defaultDirectives;
    }
       
    if(typeDefinition.settingsText){
      if(!field.typeDefinition.settingsText){
        field.typeDefinition.settingsText = {};
      }
      
      // override settings on a per-label basis 
      for(var label in typeDefinition.settingsText){
        field.typeDefinition.settingsText[label] = typeDefinition.settingsText[label].trim();
      }
    }
  }
  
  function completeSections(){

    var allSections = result.sections;
    
    //
    // gather subsections...
    //
    for(var i=0; i<allSections.length; i++){
  
      var section = allSections[i];
      
      section.directSubsections = [];
      section.allSubsections = [];
  
      var inSection = false;
  
      for(var j=0; j<allSections.length; j++){
        var s = allSections[j];
  
        if(s === section)
          inSection = true;
        else if(inSection && s.level <= section.level)
          inSection = false;
  
        if(inSection && (s.level === section.level+1)){
          section.directSubsections.push(s);
          s.parentSectionIndex = section.index
        }
  
        if(inSection && (s.level > section.level))
          section.allSubsections.push(s);
      }
      
      //
      // remove empty paragraphs...
      //
      var lastParagraph = section.paragraphs[section.paragraphs.length-1];
      
      if(!lastParagraph.offset && !lastParagraph.length)
        section.paragraphs.pop();
        
      //
      // set section lengths
      //
      if(i+1 < allSections.length){
        section.length = allSections[i+1].offset - section.offset;
      }
      else{
        section.length = result.definition.length - section.offset;
      }
    }
    
    //
    // set section lengths including subsections
    // (based on previously set section lengths)
    //
    for(var i=0; i<allSections.length; i++){
    
      var section = allSections[i];
    
      if(section.allSubsections.length > 0){
        var lastSubSection = section.allSubsections[section.allSubsections.length-1];
        section.lengthIncludeSubsections = lastSubSection.offset - section.offset + lastSubSection.length;
      } 
      else{
        section.lengthIncludeSubsections = section.length;
      }  
    }
  }

  function applyDefaultDirectives(){
    
    result.placeholders.forEach(function(placeholder){
      if(placeholder.field && placeholder.field.typeDefinition && placeholder.field.typeDefinition.defaultDirectives)
        var defaultDirectives = placeholder.field.typeDefinition.defaultDirectives;
      else
        return;

      if(!placeholder.control && defaultDirectives.control){
        placeholder.control = defaultDirectives.control;
      }
      else if(placeholder.control && !placeholder.control.name && !placeholder.control.fullName && defaultDirectives.control){
        var controlParameters = placeholder.control.parameters || {};
        var defaultControl = defaultDirectives.control;
        var mergedControl = {
          namespace: defaultControl.namespace,
          name: defaultControl.name,
          fullName: defaultControl.fullName,
          parameters: {}
        };

        if(defaultControl.condition)
          mergedControl.condition = defaultControl.condition;

        for(var defaultParamName in defaultControl.parameters || {}){
          mergedControl.parameters[defaultParamName] = defaultControl.parameters[defaultParamName];
        }

        for(var controlParamName in controlParameters){
          mergedControl.parameters[controlParamName] = controlParameters[controlParamName];
        }

        placeholder.control = mergedControl;
      }

      if(defaultDirectives.style){  
        if(!placeholder.style){
          placeholder.style = defaultDirectives.style;
        }
        else{
          for(var styleName in defaultDirectives.style){
            if(!placeholder.style[styleName]){
              placeholder.style[styleName] = defaultDirectives.style[styleName];
            }
          }
        }
      }
    });
  }

  function applyAutoWidthHints(){
    result.sections.forEach(function(section){
      section.paragraphs.forEach(function(paragraph){
        var placeholdersByLine = {};

        paragraph.placeholders.forEach(function(placeholder){
          var lineNumber = getLineNumber(result.definition, paragraph.offset, placeholder.offset);
          placeholdersByLine[lineNumber] = placeholdersByLine[lineNumber] || [];
          placeholdersByLine[lineNumber].push(placeholder);
        });

        Object.keys(placeholdersByLine).forEach(function(lineNumber){
          applyAutoWidthHintsToLine(placeholdersByLine[lineNumber]);
        });
      });
    });
  }

  function applyAutoWidthHintsToLine(placeholders){
    var missingWidthPlaceholders = [];
    var usedWidth = 0;

    placeholders.forEach(function(placeholder){
      var width = placeholder.style && placeholder.style.width && placeholder.style.width.value;

      if(!width){
        missingWidthPlaceholders.push(placeholder);
        return;
      }

      var numericWidth = getNumericPercentageWidth(width);

      if(numericWidth != null){
        usedWidth += numericWidth;
      }
    });

    if(!missingWidthPlaceholders.length){
      return;
    }

    var remainingWidth = 100 - usedWidth;

    if(remainingWidth <= 0){
      return;
    }

    var widthPerMissingPlaceholder = remainingWidth / missingWidthPlaceholders.length;
    var widthValue = formatAutoWidth(widthPerMissingPlaceholder);

    missingWidthPlaceholders.forEach(function(placeholder){
      placeholder.style = placeholder.style || {};
      placeholder.style.width = { value: widthValue };
    });
  }

  function getNumericPercentageWidth(width){
    if(/^\d+(\.\d+)?%?$/.test(width)){
      return Number(width.replace('%', ''));
    }

    return null;
  }

  function formatAutoWidth(width){
    var roundedWidth = Math.round(width * 10000) / 10000;
    return Number.isInteger(roundedWidth) ? String(roundedWidth) : roundedWidth + '%';
  }

  function getLineNumber(text, offsetStart, offsetEnd){
    var lineNumber = 0;

    for(var i = offsetStart; i < offsetEnd; i++){
      if(text[i] === '\n'){
        lineNumber++;
      }
    }

    return lineNumber;
  }
  
  function log(text){
    result.log += text + "\n";
  }

  peg$result = peg$startRuleFunction();

  if (options.peg$library) {
    return /** @type {any} */ ({
      peg$result,
      peg$currPos,
      peg$FAILED,
      peg$maxFailExpected,
      peg$maxFailPos
    });
  }
  if (peg$result !== peg$FAILED && peg$currPos === input.length) {
    return peg$result;
  } else {
    if (peg$result !== peg$FAILED && peg$currPos < input.length) {
      peg$fail(peg$endExpectation());
    }

    throw peg$buildStructuredError(
      peg$maxFailExpected,
      peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null,
      peg$maxFailPos < input.length
        ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
        : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
    );
  }
}

const peg$allowedStartRules = [
  "Start"
];

export {
  peg$allowedStartRules as StartRules,
  peg$SyntaxError as SyntaxError,
  peg$parse as parse
};
